{
  "common" : {
    "show" : "Afficher",
    "about" : "À propos",
    "newPost" : "Nouveau poste",
    "active" : "Actif",
    "change" : "Changement",
    "remove" : "Supprimer",
    "cancel" : "Annuler",
    "publish" : "Publier",
    "save" : "Sauvegarder",
    "draft" : "Ébauche",
    "scheduled" : "Prévu",
    "published" : "Publié",
    "actions" : "Actions",
    "archive" : "Archives",
    "delete" : "Supprimer",
    "edit" : "Modifier",
    "edited" : "Modifié",
    "settings" : "Réglages",
    "signUp" : "S'inscrire",
    "by" : "Par",
    "for" : "pour",
    "you" : "Vous",
    "one" : "un",
    "option" : "Option ",
    "registered" : "Inscrit",
    "to" : "à",
    "allEvents" : "Tous les événements",
    "placeholder" : "substitut",
    "percentOf" : "% de",
    "private" : "Privé",
    "updatedOn" : "Mise à jour le",
    "blogPost" : "Article de blogue",
    "category" : "Catégorie",
    "author" : "Auteur",
    "status" : "Statut",
    "errors" : {
      "label" : "Erreurs",
      "SOMETHING_WENT_WRONG" : "Une erreur s'est produite. Veuillez réessayer plus tard."
    },
    "all" : "Tous",
    "archived" : " Archivé",
    "back" : "Retour",
    "restore" : "Restaurer cette version",
    "next" : "Suivant",
    "previous" : "Précédent",
    "continue" : "Continuer",
    "continueButton" : "Continuer",
    "paid" : "Payé",
    "free" : "Gratuit",
    "uploadImagesVideos" : "Téléverser des images / vidéos",
    "upload" : "Téléverser",
    "add" : "Ajouter",
    "on" : "Allumé",
    "from" : "de",
    "members" : "membres",
    "visibility" : "Visibilité",
    "public" : "Public",
    "description" : "Description",
    "managedBy" : "Géré par",
    "noManagers" : "Aucun gestionnaire",
    "noDescription" : "Aucune description",
    "more" : "Plus",
    "moreCaps" : "Plus",
    "less" : "moins",
    "and" : "et",
    "in" : "in",
    "allSet" : "Vous êtes prêt !",
    "createdBy" : "Créé par",
    "home" : "Accueil",
    "selected" : "Sélectionné",
    "groupMembers" : "Membres du groupe",
    "everyone" : "Tout le monde",
    "manager" : "Gestionnaire",
    "leave" : "Quitter",
    "membersList" : "Liste des membres",
    "findChannelManagers" : "Rechercher les gestionnaires de canaux",
    "searchGroupMembers" : "Recherche de membres du groupe",
    "searchMembers" : "Recherche de membres",
    "searchMember" : "Rechercher un membre",
    "enterDescription" : "Saisissez la description",
    "apply" : "Applique",
    "selectRole" : "Sélectionner un rôle",
    "people" : "Les personnes",
    "viewProfile" : "Afficher le profil",
    "leaderboard" : "Leaderboard",
    "events" : "Événements",
    "logOut" : "Se déconnecter",
    "topLevelReached" : "Niveau supérieur atteint",
    "topLevelReachedExclaim" : "Niveau supérieur atteint!",
    "congratsTopLevel" : "Félicitations! Vous avez atteint le plus haut niveau!",
    "share" : "Partager",
    "copyLink" : "Copier le lien",
    "reply" : "Réponse",
    "download" : "Télécharger",
    "noPreviewAvailable" : "Aucun aperçu disponible",
    "userNotFound" : "Utilisateur non trouvé",
    "userNotFoundMessage" : "Utilisateur introuvable",
    "thisGroupIsPrivate" : "Ce groupe est privé",
    "unableToPreviewPdf" : "Actuellement, impossible de prévisualiser le fichier PDF. Veuillez le télécharger pour le voir.",
    "failedToDownloadPdf" : "Impossible de télécharger le fichier PDF",
    "notifyAll" : "Notifier tout le monde sur le canal",
    "communities" : "Communautés",
    "courses" : "Cours",
    "affiliates" : "Affiliation",
    "chats" : "Clavardage",
    "switchToDarkMode" : "Passer en mode Foncé",
    "switchToLightMode" : "Passer en mode lumière",
    "editProfile" : "Modifier le profil",
    "account" : "Compte",
    "logout" : "Déconnexion",
    "noResults" : "Aucun résultat",
    "confirmPayment" : "Confirmer le paiement",
    "done" : "Terminé",
    "manage" : "GÉRER",
    "copied" : "Copié",
    "submit" : "Soumettre",
    "request" : "Demande",
    "approve" : "Approuver",
    "decline" : "Refuser",
    "comingSoon" : "Bientôt disponible",
    "detailsUpdatedSuccessfully" : "Info mise à jour avec succès",
    "oopsUnableToSaveDetails" : "Oups! Impossible d'enregistrer les détails.",
    "verificationFailedPleaseTryAgain" : "La vérification a échoué! Veuillez réessayer",
    "loading" : "Chargement",
    "title" : "Titre",
    "addLink" : "Ajouter un lien",
    "writeHere" : "Écrire ici",
    "copy" : "Copier",
    "reset" : "Réinitialiser",
    "register" : "S'inscrire",
    "search" : "Rechercher",
    "confirm" : "Confirme",
    "success" : "Succès",
    "toReview" : "Pour Avis",
    "invite" : "Invite",
    "contributions" : "Conversations",
    "communitiesSettings" : "Réglages de la communauté",
    "create" : "Créer",
    "name" : "Nom",
    "linkCopied" : "Lien Copié!",
    "move" : "Déplacer",
    "irreversible" : "irréversible",
    "close" : "Fermer",
    "greeting" : "Hier, {name} vous",
    "managePayments" : "Gérer les paiements",
    "manageYourAccount" : "Gérer votre Compte",
    "accountSettings" : "Réglages du Compte",
    "proceed" : "Poursuivre",
    "uploading" : "Téléversement",
    "retry" : "Réessayer",
    "login" : "Ouvrir une session",
    "follow" : "Suivre",
    "following" : "Suivant",
    "followers" : "Abonnés",
    "view" : "Voir",
    "selectAnOption" : "Sélectionner une option",
    "channels" : "Chaînes",
    "somethingWentWrong" : "Un problème est survenu, veuillez réessayer",
    "switchToNormalMode" : "Passez en mode normal",
    "switchToReadingMode" : "Passez en mode lecture",
    "goToHomepage" : "Aller à la page d’accueil",
    "onlyGroupOwnersCanCreateCourses" : "Seuls les propriétaires de groupes peuvent créer de nouveaux cours",
    "createGroup" : "Créer un groupe",
    "discover" : "Découvrir",
    "continuePayment" : "Continuer le paiement",
    "invalidCredentials" : "Vous avez saisi un courriel ou un mot de passe invalide. Veuillez réessayer.",
    "comingUpEvents" : "Événements à venir!",
    "integratePaymentGateway" : "Intégrez la passerelle de paiement",
    "connectPaymentGateway" : "Connectez une nouvelle passerelle de paiement ou gérez vos passerelles existantes.",
    "isLive" : "est En direct",
    "justNow" : "Tout de suite",
    "likes" : "mentions \"j'aime\"",
    "accessRequired" : "Accès*",
    "zeroProgress" : "0",
    "noFollowersTitle" : "Il semble que personne ne vous Suivre.",
    "noFollowersSubtext" : "Ajouter votre connexion à la Liste Suivre",
    "noFollowingTitle" : "Vous ne suivez encore personne.",
    "noFollowingSubtext" : "Début à Suivant des personnes pour voir leurs publications",
    "followBack" : "Suivre en retour",
    "logIn" : "LOG IN",
    "video" : "Vidéo",
    "audio" : "Audio",
    "newVersionAvailable" : "Une nouvelle version de l'application est disponible. Veuillez mettre à jour pour utiliser cette fonctionnalité !",
    "ariaLabels" : {
      "backButton" : "Bouton Retour",
      "openEventLocation" : "Ouvrir l'emplacement de l'événement",
      "editEvent" : "Modifier l'événement",
      "deleteEvent" : "Supprimer l’événement",
      "cancelRsvp" : "Annuler RSVP",
      "publicGroupRadio" : "Bouton Radio de groupe public",
      "privateGroupRadio" : "Bouton radio de groupe privé",
      "accessibleFromSwitcherCheckbox" : "Accessible depuis la case à cocher du commutateur",
      "allowMembersToInviteCheckbox" : "Case à cocher « Autoriser les Membres à inviter »",
      "addMembers" : "Ajouter des membres",
      "settings" : "Paramètres",
      "leaveChannel" : "Quitter le canal",
      "channelSettings" : "Paramètres du canal",
      "selectRole" : "Sélectionner un rôle",
      "deleteChannel" : "Supprimer le canal",
      "changeToPrivateChannel" : "Passer en canal privé",
      "allowMembersToPosts" : "Permettre aux membres de publier",
      "restrictMembersFromPosts" : "Empêcher les membres d'envoyer des publications",
      "close" : "Fermer",
      "open" : "Ouvrir",
      "more" : "Plus",
      "upload" : "Téléverser",
      "play" : "Lecture",
      "pause" : "Pause",
      "mute" : "Silencieux",
      "unmute" : "Réactivez le son",
      "fullscreen" : "Plein écran",
      "exitFullscreen" : "Quitter le plein écran",
      "download" : "Télécharger",
      "share" : "Partager",
      "like" : "J'aime",
      "comment" : "Commentaire",
      "reply" : "Répondre",
      "pin" : "Épingler",
      "unpin" : "Désépingler",
      "report" : "Rapport",
      "copyLink" : "Copier le lien",
      "embedCode" : "Code d'intégration",
      "previewImage" : "Aperçu de l'image",
      "profileImage" : "Image de profil",
      "coverImage" : "Image de couverture",
      "thumbnail" : "Miniatures",
      "attachment" : "Pièce jointe",
      "removeAttachment" : "Supprimez la pièce jointe",
      "uploadFile" : "Téléverser un fichier",
      "selectFile" : "Sélectionner un fichier",
      "searchIcon" : "Icône de Recherche",
      "menuIcon" : "Icône de menu",
      "notification" : "Notification",
      "messages" : "Messages",
      "profile" : "Profil",
      "logout" : "Déconnexion",
      "send" : "Envoyer",
      "cancel" : "Annuler",
      "submit" : "Soumettre",
      "next" : "Suivant",
      "previous" : "Précédent",
      "refresh" : "Rafraîchir",
      "filter" : "Filtre",
      "sort" : "Trier",
      "view" : "Voir",
      "expand" : "Afficher plus",
      "collapse" : "Effondrement",
      "downloadFile" : "Télécharger le fichier",
      "closeModal" : "Fermer la fenêtre modale",
      "addMedia" : "Ajouter des médias",
      "lightModeRadio" : "Bouton Radio en mode Léger",
      "darkModeRadio" : "Bouton radio en mode sombre",
      "communityThemeRadio" : "Bouton radio à thème communautaire",
      "userProfile" : "Profil Utilisateur",
      "postActions" : "Actions après publication",
      "chatWindow" : "Fenêtre de clavardage",
      "chatActions" : "Actions de Clavardage",
      "minimizeChat" : "Réduire le clavardage",
      "closeChat" : "Fermer le clavardage",
      "commentActions" : "Actions sur le commentaire",
      "replyToComment" : "Répondre au commentaire",
      "groupLogo" : "Logo du groupe",
      "pinGroupIcon" : "Épingler l'icône du groupe",
      "appSwitcher" : "Commutateur d’applications",
      "communities" : "Communautés",
      "courses" : "Cours",
      "search" : "Rechercher",
      "giphyLogo" : "Logo de Giphy",
      "backToConversations" : "Retour aux Conversations",
      "commentAttachments" : "Pièces jointes aux commentaires",
      "tabSwitcher" : "Commutateur d'onglets",
      "eventCover" : "Couverture d'événement",
      "eventCoverPreview" : "Aperçu de la couverture de l’événement",
      "selectPaidEvent" : "Sélection d’événements payants",
      "selectFreeEvent" : "Sélectionner un événement gratuit",
      "selectCurrency" : "Sélectionner la devise",
      "logo" : "Logo",
      "closeReviewMembershipAnswersModal" : "Fermer la fenêtre modale des réponses des membres",
      "liveStream" : "Diffusion en direct",
      "openGroupMembers" : "Groupe de membres ouvert",
      "communityBanner" : "Bannière communautaire",
      "home" : "Accueil",
      "mentionItem" : "Mentionner l’article",
      "back" : "Retour",
      "viewGroup" : "Voir le groupe",
      "invitationIcon" : "Icône d'invitation",
      "openUserProfile" : "Ouvrir le profil de l'utilisateur",
      "closeStream" : "Fermer la diffusion en direct",
      "groupAvatar" : "Avatar de groupe",
      "bannerImage" : "Image de la bannière",
      "avatarImage" : "Image de l'avatar",
      "userAvatar" : "Avatar d'utilisateur",
      "eventImage" : "Image d’événement",
      "postImage" : "Image de publication",
      "channelIcon" : "Icône de Canal",
      "groupIcon" : "Icône de groupe",
      "communityIcon" : "Icône de la communauté",
      "memberAvatar" : "Avatar du membre",
      "creatorAvatar" : "Avatar du créateur",
      "authorAvatar" : "Avatar de l’auteur",
      "aboutFeaturedPost" : "A propos de la publication vedette",
      "accountSettings" : "Paramètres du compte",
      "addChannel" : "Ajouter un canal",
      "addCourse" : "Ajouter un cours",
      "addEmoji" : "Ajouter un emoji",
      "affiliates" : "Affiliés",
      "announceEvents" : "Annoncer les événements",
      "avatar" : "Avatar",
      "badge" : "Badge",
      "camera" : "Caméra",
      "cardImage" : "Image de Carte",
      "categoryName" : "Nom de la catégorie",
      "channelList" : "Liste des Canaux",
      "channelSelect" : "Sélection de canal",
      "chatAttachment" : "Pièce jointe de clavardage",
      "chats" : "Clavardages",
      "closeCourseDetails" : "Fermer les détails du cours",
      "closeLoginModal" : "Fermer la fenêtre modale de connexion",
      "closeMembershipQuestionsModal" : "Fermer la fenêtre modale des questions sur l’adhésion",
      "closePaymentModal" : "Fermer la fenêtre modale de paiement",
      "commentCard" : "Carte de commentaire",
      "communityTheme" : "Thème communautaire",
      "conversationItem" : "Point de conversation",
      "conversationSuggestion" : "Suggestion de conversation",
      "createChannel" : "Créer un canal",
      "customThemeRadio" : "Bouton radio à thème personnalisé",
      "deleteAnswerButton" : "Bouton Supprimer la Réponse",
      "deleteFile" : "Supprimer le fichier",
      "editLevelName" : "Modifier le nom du niveau",
      "editProfile" : "Modifier le profil",
      "enterEmailAddress" : "Entrer l’adresse courriel",
      "featuredIcon" : "Icône en vedette",
      "giveAdministrativePrivileges" : "Conférer des privilèges administratifs",
      "gokollabLogo" : "Logo Gokollab",
      "icon" : "Icône",
      "image" : "Image",
      "likeContent" : "Aimer le contenu",
      "link" : "Lien",
      "marketplaceGroupSlug" : "Groupe Slug du marché",
      "microphone" : "Microphone",
      "nextAttachment" : "Pièce jointe suivante",
      "noEvents" : "Aucun événement",
      "noCommunitiesIllustration" : "Aucune illustration de communautés",
      "noCoursesFound" : "Aucun cours trouvé",
      "noFollowers" : "Aucun Suiveurs",
      "noFollowing" : "Aucun suivi",
      "noPostsFound" : "Aucun publication trouvée",
      "notificationItem" : "Point de notification",
      "notificationsList" : "Liste des Notifications",
      "openEmbeds" : "Ouvrir les intégrations",
      "openEmbedsDrawer" : "Ouvrir le tiroir des intégrations",
      "openEventColor" : "Ouvrir la couleur de l'événement",
      "openEventDetails" : "Ouvrir les détails de l’événement",
      "permissionNeeded" : "Autorisation nécessaire",
      "pointsAndLevels" : "Points & Niveaux",
      "previousAttachment" : "Pièce jointe précédente",
      "reactedUser" : "Utilisateur ayant réagi",
      "reward" : "Récompense",
      "rewards" : "Récompenses",
      "selectChannel" : "Sélectionnez le canal",
      "selectEventOption" : "Sélectionner l'option d'événement",
      "selectIcon" : "Sélectionner une icône",
      "selectTimezone" : "Sélectionner le fuseau horaire",
      "showChannelIcons" : "Afficher les icônes des canaux",
      "sidebarActionButton" : "Bouton d’action dans la barre latérale",
      "speaker" : "Haut-parleur",
      "text" : "Texte",
      "thisGroupIsPrivate" : "Cette Collection est privée",
      "toReview" : "À examiner",
      "toggleFeaturedPost" : "Activer/désactiver la publication en vedette",
      "toggleRewardsOptions" : "Activer/désactiver les options de récompenses",
      "viewReplies" : "Voir les réponses",
      "courseThumbnail" : "Miniature de cours",
      "moreManagers" : "plus de gestionnaires",
      "arrowIcon" : "→",
      "okHandEmoji" : "👌",
      "closeIcon" : "✕",
      "changeToPublicChannel" : "Passer en canal public",
      "showMandatoryInfoModal" : "Afficher la case à cocher obligatoire du profil modal"
    },
    "placeholders" : {
      "groupName" : "Nom du groupe",
      "groupSlug" : "Groupe Slug",
      "url" : "URL",
      "enterPrice" : "Entrez le prix",
      "enterName" : "Entrez le nom",
      "enterEmail" : "Entrez le courriel",
      "selectTimezone" : "Sélectionner le fuseau horaire",
      "selectChannel" : "Sélectionnez le canal",
      "enterSkoolGroupUrl" : "Saisissez l'URL du groupe de votre Skool"
    },
    "email" : "Courriel",
    "errorLoadingConversations" : "Erreur lors du chargement des conversations",
    "noConversations" : "Aucune conversation"
  },
  "imageUpload" : {
    "cropYourAvatar" : "Cropez votre avatar",
    "dragToReposition" : "Traîner pour repositionner",
    "ariaLabels" : {
      "imageUploader" : "Téléverseur d'images",
      "avatar" : "Avatar",
      "clearFile" : "Effacer le fichier",
      "removeAvatar" : "Supprimer l'avatar du profil",
      "zoomButton" : "Bouton Zoom"
    }
  },
  "mediaUpload" : {
    "uploadVideo" : "Téléverser la vidéo",
    "addVideoUsingLink" : "Ajouter une vidéo à l’aide d’un lien",
    "uploadImage" : "Téléverser une image",
    "addVideo" : "Ajouter une vidéo"
  },
  "mandatedInfoModal" : {
    "completeYourProfile" : "Finissez votre Profil",
    "profileIntentMessage1" : "Les communautés semblent étranges sans visages ni noms.",
    "profileIntentMessage2" : "Les profils instaurent la confiance et créent des liens avec les autres",
    "complete" : "COMPLET",
    "recommendedAspectRatio" : "Téléverser un {types} Recommander l'apparence 1:1",
    "addBio" : "Ajouter une biographie... (En option)"
  },
  "validations" : {
    "nameRequired" : "Le nom est obligatoire",
    "invalidDescription" : "Description invalide!"
  },
  "payment" : {
    "recurringWithTrial" : "Vous serez facturé {currencySymbol}{price} par {interval} après la période d'essai terminée avec la possibilité d'annuler à tout moment.",
    "recurring" : "{currencySymbol}{price} par {interval} avec la possibilité d'annuler à tout moment.",
    "oneTime" : "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText" : "Prix unique pour l'abonnement.",
    "totalAmount" : "Montant total",
    "viewBreakdown" : "Voir la répartition",
    "hideBreakdown" : "Masquer la répartition",
    "subtotal" : "Sous-total",
    "salesTax" : "Taxe de vente",
    "taxesMayApply" : "Des taxes peuvent s'appliquer lors du paiement.",
    "inclTax" : "Taxe comprise",
    "totalDueToday" : "Somme due aujourd'hui",
    "trialDays" : "{days} Essai d'une journée",
    "securePayments" : "Paiements 100% sécurisés et sûrs",
    "allowToChargeCard" : "En fournissant les informations de votre carte, vous autorisez {locationName} à charger la carte pour les paiements futurs conformément à leurs conditions.",
    "address" : {
      "country" : "Pays",
      "state" : "État",
      "zipCode" : "Code postal",
      "city" : "Ville",
      "addressLine1" : "Adresse ligne 1",
      "addressLine2" : "Ligne d'adresse 2 (facultatif)",
      "streetAndNumber" : "Rue et numéro",
      "apartmentAndUnit" : "Appartement, suite, unité, bâtiment, étage, etc.",
      "selectCountry" : "Sélectionnez le pays",
      "selectState" : "Sélectionnez l'état",
      "calculatingTaxes" : "Calcul des taxes",
      "continueToPayment" : "Continuer vers le paiement",
      "validationError" : "Veuillez remplir tous les champs d'adresse obligatoires.",
      "taxInfo" : "Nous utilisons votre adresse uniquement pour calculer les taxes applicables."
    },
    "paymentSuccessful" : "Paiement réussi!",
    "errors" : {
      "FDS_DECLINED" : "Votre transaction a été refusée. Veuillez communiquer avec le propriétaire de l'entreprise."
    }
  },
  "channel" : {
    "notifications" : {
      "managersEdited" : "Gestionnaires édités avec succès!",
      "managersAdded" : "Gestionnaires ajoutés avec succès!",
      "managersAddedToChannel" : "gestionnaires ajoutés à",
      "membersAdded" : "Membres ajoutés avec succès!",
      "memberPostingEnabled" : {
        "title" : "Mise à jour avec succès",
        "content" : "La publication des membres a été active"
      },
      "roleUpdated" : "Rôle mis à jour avec succès!",
      "updatedRoleOf" : "Rôle mis à jour de {name}",
      "userRemoved" : "Utilisateur retiré avec succès!",
      "removedUserFrom" : "Suppression de {name} de {channelName}",
      "errorOccurred" : "Une erreur s’est produite",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND" : "Impossible de mettre à jour le rôle car ce membre est introuvable.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN" : "Cette action n'est pas permise pour le propriétaire du groupe.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND" : "Impossible de supprimer l'utilisateur car ce membre est introuvable.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND" : "Impossible de supprimer l'utilisateur car ce canal n'a pas été trouvé.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN" : "Le propriétaire du groupe ne peut pas être retiré du canal.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL" : "Cet utilisateur ne fait pas partie du canal sélectionné.",
      "updated" : {
        "title" : "Paramètres de canal mis à jour",
        "contentPrivate" : "Le canal {channelName} est maintenant privé",
        "contentPublic" : "Le canal {channelName} est maintenant public",
        "content" : ""
      },
      "deleted" : {
        "title" : "La chaîne a été supprimée avec succès",
        "content" : ""
      },
      "membersAddedSuccess" : {
        "title" : "Membres ajoutés avec succès!",
        "content" : "{count} membres ont été ajoutés à {channelName}"
      },
      "managersAddedSuccess" : {
        "title" : "Gestionnaires ajoutés avec succès!",
        "content" : "{count} gestionnaires ajoutés à {channelName}"
      },
      "memberPostingDisabled" : {
        "title" : "Mise à jour avec succès",
        "content" : "Les membres de la publication ont été Handicapés"
      },
      "visibilityChangedToPublic" : "Le canal {channelName} est maintenant public",
      "visibilityChangedToPrivate" : "Le canal {channelName} est maintenant privé",
      "created" : {
        "title" : "Nouvelle chaîne créée",
        "content" : ""
      },
      "error" : {
        "createFailed" : {
          "title" : "Impossible de créer un canal",
          "content" : "Veuillez réessayer plus tard"
        },
        "updateFailed" : {
          "title" : "Échec de la mise à jour de la chaîne",
          "content" : "Veuillez réessayer plus tard"
        },
        "managersEditedFailed" : {
          "title" : "La mise à jour des gestionnaires a échoué!",
          "content" : ""
        },
        "addFailed" : {
          "title" : "L'ajout de gestionnaires n'est pas un succès!",
          "content" : ""
        },
        "addMembersFailed" : {
          "title" : "L'ajout de membres a échoué!",
          "content" : ""
        }
      }
    },
    "createChannel" : "Créer un canal",
    "updateChannel" : "Canal de mise à jour",
    "addMembers" : "Ajouter des membres",
    "addManagers" : "Ajouter des gestionnaires",
    "typeToAddMoreMembers" : "Type pour inclure plus de membres",
    "examplePlaceholder" : "ex. John ou Jane",
    "makeChannelManager" : "Créer un gestionnaire de canaux",
    "removeFromChannelManager" : "Extraire du Gestionnaire de canaux",
    "manager" : "Gestionnaire",
    "channelManager" : "Gestionnaire de canaux",
    "noMembersFound" : "Aucun membre trouvé.",
    "noManagersFound" : "Aucun gestionnaire trouvé.",
    "removeChannelMember" : "Extraire le membre de canal",
    "removeConfirmationMessage" : "Êtes-vous sûr de vouloir supprimer",
    "makeManagerConfirmationMessage" : "Voulez-vous vraiment faire",
    "makeManagerConfirmationMessage2" : "un gestionnaire de chaîne in",
    "channelName" : "Nom du canal",
    "channelIcon" : "Icône de chaîne",
    "addChannel" : "Ajouter une chaîne",
    "editChannel" : "Modifier le Canal",
    "announcementChannel" : "Canal AVIS",
    "noChannelsAvailable" : "Aucun canal disponible",
    "makeChannelPrivate" : "Rendre le canal Privé",
    "makeChannelPrivateMessage" : "Restreindre l'accès des membres à toutes les discussions et les interactions du canal.",
    "readOnlyChannel" : "Canal de Lire seule",
    "readOnlyChannelMessage" : "Les membres peuvent afficher des informations et des informations IMPORTANT , mais seules les administrateurs/ propriétaires du canal peuvent partager ici.",
    "createPrivateChannel" : "Rendre ce canal privé",
    "createPrivateChannelMessage" : "Seuls les Membres invités. Aucun membre ne verra cet Espace",
    "allowMembersToPost" : "Membres actifs à partager",
    "allowMembersToPostMessage" : "Activer cette option pour créer des publications et des commentaires",
    "enableMemberPostingConfirmation" : {
      "mainMessage" : "L'activation des membres de l'activation des membres de l'activation de la publication d'annonces de membres actifs pour créer et partager des publications au sein du canal.",
      "mainMessage2" : "Assurez-vous que tous les membres sont marqués des nouvelles autorisations de publication.",
      "pointer1" : "Cette Action peut être annulée à n'importe quelle Date.",
      "pointer2" : "Toutes les publications créées par les membres seront visibles par Tout le monde in le canal."
    },
    "privateChannelTooltip" : "Vous n'avez pas accès à ce canal",
    "restrictMembersFromPosting" : "Empêcher les membres de soumettre",
    "restrictMembersFromPostingMessage" : "La désactivation de cette option empêchera les membres de la modification de la publication et de l'avis au sein du canal.",
    "disableMemberPostingConfirmation" : {
      "mainMessage" : "Désactiver les membres de la publication empêchera tout membre de l'équipe et le partage des publications au sein du canal.",
      "mainMessage2" : "Assurez-vous que tous les membres sont marqués par les nouveaux restrictions de publication.",
      "pointer1" : "Cette Action peut être annulée à n'importe quelle Date.",
      "pointer2" : "Tous les publications créés par les membres avant ce changement resteront visibles pour tout le monde in le canal."
    },
    "deleteChannel" : "Supprimer le canal",
    "deleteChannelMessage" : "La suppression du canal entraîne la perte définitive de toutes les données qui y sont associées.",
    "deleteChannelMessageWithCourse" : "La Supprimer du canal empêchera définitivement la suppression de toutes les données et tous les Cours liés à ce canal Public à moins que vous les supprimerez en premier.",
    "editChannelName" : "Modifier le nom du canal",
    "editChannelDescription" : "Modifier la description du canal",
    "channelNamePlaceholder" : "par exemple Rapports marketing",
    "editManagers" : "Modifier les gestionnaires",
    "channelManagers" : "Gestionnaires de canaux",
    "leaveChannel" : "Abandonner la chaîne",
    "leaveChannelConfirmation" : "Voulez-vous vraiment quitter ce canal?",
    "changeToPrivateChannel" : "Rendre le canal Privé",
    "changeToPrivateChannelMessage" : "Rendre le canal privé limitera l'utilisation du canal pour les interactions et les discussions à ses membres uniquement.",
    "changeToPrivateChannelConfirmation" : {
      "mainMessage" : "Le changement de ce canal pour le privé empêchera le nombre maximal d'emplacements pour la sélection des membres et des administrateurs.",
      "mainMessage2" : "N'oubliez pas d'inclure les membres de votre choix dans votre canal privé.",
      "pointer1" : "Cette Action est",
      "pointer2" : "Les nouveaux membres ajoutés au canal auront accès pour toutes les discussions et les contacts au sein du canal."
    },
    "changeToPublicChannel" : "Rendre le canal public",
    "changeToPublicChannelMessage" : "Rendre le canal public permettra à tout le monde dans le groupe de voir et de rejoindre ce canal.",
    "changeToPublicChannelConfirmation" : {
      "mainMessage" : "Créer ce canal public le rendra accessible à tous les membres de la communauté.",
      "mainMessage2" : "Tous les membres du groupe pourront voir et rejoindre ce canal.",
      "pointer1" : "Tous les membres du groupe auront accès à ce canal automatiquement.",
      "pointer2" : "Le contenu des anciens canaux privés deviendra visible pour tous les membres du groupe."
    },
    "publicChannel" : "Canal public",
    "peopleWhoCanManage" : "Des gens qui peuvent gérer",
    "addChannelHelperText" : "Afficher plus la communauté : Ajouter des canaux pour des discussions, Duet et une connexion.",
    "privateChannel" : "Canal privé",
    "removeFromChannel" : "Retirer du canal",
    "removeConfirmationMessage2" : "de ce canal",
    "findChannelManagers" : "Trouver des gestionnaires de canaux",
    "removeChannelManager" : "Supprimer le gestionnaire de canaux",
    "irreversible" : "Cette action est irréversible"
  },
  "chat" : {
    "unblockUser" : "Débloquer l'utilisateur",
    "blockUser" : "Bloquer l'utilisateur",
    "blockMessage1" : "Vous ne pourrez plus envoyer de messages à cet utilisateur.",
    "blockMessage2" : "Ce compte ne sera pas bloqué sur le groupe. Vous pourrez peut-être toujours voir leurs publications, commentaires et réactions.",
    "deleteChat" : "Supprimer le chat",
    "deleteChatMessage" : "Voulez-vous vraiment supprimer cette conversation?",
    "block" : "Bloquer",
    "conversation" : "conversation",
    "youPrefix" : "Vous : ",
    "messageNotSent" : "Ce message n'a pas été envoyé",
    "sending" : "Envoi...",
    "youAndUserKnowEachOther" : "Vous et {name} vous vous connaissez",
    "startConversationWithHi" : "Commencez une conversation en envoyant « Salut »",
    "accountSettings" : "Paramètres du Compte",
    "blockedUserMessage" : "Vous avez bloqué { name }, Vous ne pouvez ni envoyer ni recevoir de messages. Débloquez-les pour démarrer une conversation. Pour consulter votre liste d'utilisateurs bloqués, visitez votre",
    "blockRecipientMessage" : "{ name } vous a bloqué. Vous ne pouvez pas envoyer ou recevoir de messages.",
    "nothingFound" : "Rien n'a été trouvé!",
    "pleaseCheckUsername" : "Veuillez vérifier le nom d'utilisateur et réessayer",
    "startChatting" : "Commencer à chatter",
    "noChatYet" : "Apparence que vous n'avez encore discuté avec personne.",
    "noChatYetMessage" : "Recherchez un contact et faites le premier pas!",
    "noConversationsFound" : "Aucune conversation trouvée",
    "searchMembersAndStartChatting" : "Recherche des Membres et commencez à discuter",
    "cannotMessageDeletedUser" : "Vous ne pouvez pas téléverser des messages à un utilisateur pris en charge",
    "message" : "Message",
    "media" : "Médias",
    "files" : "Fichiers"
  },
  "comments" : {
    "reportComment" : "Signaler un commentaire",
    "reportCommentMessage" : "Êtes-vous sûr de vouloir signaler ce commentaire ?",
    "deleteComment" : "Supprimer un commentaire",
    "editComment" : "Modifier le commentaire",
    "loadMoreReplies" : "Charger plus de réponses",
    "deleteCommentMessage" : "Voulez-vous vraiment supprimer ce commentaire ?",
    "writeComment" : "Écrire un commentaire",
    "comment" : "COMMENTER",
    "cancel" : "ANNULER",
    "save" : "ENREGISTRER",
    "replyingTo" : "En réponse à",
    "newComment" : "Nouveau commentaire",
    "latest" : "Dernier",
    "onlyAdminsCanComment" : "Seuls les administrateurs de la communauté peuvent commenter in ce canal.",
    "isCommentDisabledForPost" : "Les commentaires sont désactivés pour cette publication.",
    "isCommentDisabledErrorContent" : "Les commentaires ont été désactivés sur cette publication par l'auteur ou l'administrateur du groupe.",
    "isCommentDisabledErrorTitle" : "Commentaires désactivés",
    "notifications" : {
      "saveComment" : "Erreur lors de l'enregistrement du commentaire",
      "error" : "Une erreur s'est produite, veuillez réessayer plus tard.",
      "COMMENT_CONTENT_SIZE_EXCEEDED" : "Le contenu du commentaire est trop volumineux. Veuillez réduire la taille et réessayer.",
      "COMMENTS_DISABLED" : "Les commentaires ont été désactivés sur cette publication par l'auteur ou l'administrateur du groupe."
    }
  },
  "embeds" : {
    "uploadImage" : "Téléverser une photo",
    "addYoutubeVimeoLoomLink" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadAttachment" : "Téléverser des fichiers PDF, CSV ou XLSX",
    "addAttachment" : "Ajouter une pièce jointe",
    "allowedTypes" : "SVG, PNG, JPG ou GIF (max. (800x400px)",
    "placeholder" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideo" : "Téléverser/Lier une Vidéo",
    "uploadVideoPlaceholder" : "Ajoutez un lien Youtube, Vimeo ou Loom",
    "uploadVideoAllowedTypes" : "Téléverser un fichier vidéo MP4",
    "addEmoji" : "Ajouter des émojis",
    "emojiSuggestion" : "Ouvre le sélecteur d'Emoji",
    "addGif" : "Ajouter un GIF",
    "gifSuggestion" : "Ouvre le sélecteur de GIF",
    "addImage" : "Ajouter une image",
    "imageSuggestion" : "Ouvre votre galerie",
    "addVideo" : "Ajouter une vidéo",
    "videoSuggestion" : "Ouvre votre galerie",
    "selectFile" : "Sélectionner le fichier",
    "attachmentSuggestion" : "Ouvre le gestionnaire de fichiers",
    "takePhoto" : "Prendre une photo",
    "uploadPhotoVideo" : "Téléverser une photo/vidéo",
    "limitExceeded" : "Limite dépassée",
    "limitExceededMessage" : "Vous ne pouvez pas joindre plus de 4 fichiers",
    "errorWhileUploadingFile" : "Erreur lors du téléchargement du fichier! Veuillez réessayer",
    "notifications" : {
      "uploadError" : "Erreur lors du téléchargement du fichier",
      "FILE_SIZE_EXCEEDED" : "La taille du fichier dépasse la limite maximale de téléversement de 50 Mo.",
      "VIDEO_SIZE_EXCEEDED" : "La taille de la vidéo dépasse la limite maximale de téléversement de 2 Go."
    },
    "clickToUpload" : "Clique pour télécharger",
    "orDragAndDrop" : "ou glisser-déposer",
    "validUrl" : "Une URL valide est nécessaire",
    "enterSomeText" : "Saisissez du texte",
    "addLink" : "Ajouter un lien",
    "text" : "Texte",
    "addVideoLink" : "YouTubeVimeo Wistia",
    "uploadVideoAndImages" : "Téléverser des vidéo et des images",
    "recommendedAspectRatio" : "Pourcentage {ratio}apparence",
    "addHashtag" : "Marquer les chaînes, les événements et les cours",
    "hashtagSuggestion" : "Suggestion de Hashtag"
  },
  "tabSwitcher" : {
    "discussion" : "Discussion",
    "learning" : "Apprentissage",
    "members" : "Membres",
    "people" : "Personnes",
    "leaderboard" : "Leaderboard",
    "channels" : "Canal",
    "groups" : "Groupes",
    "more" : "Plus",
    "home" : "Accueil",
    "discover" : "Découvrir",
    "courses" : "Cours",
    "communities" : "Communautés"
  },
  "groupInfo" : {
    "pinGroup" : "Groupe de pipeline",
    "unpinGroup" : "Groupe non .",
    "maxPinnedGroupsLimit" : "Seuls 4 groupes au maximum peuvent être définis",
    "publicGroup" : "Groupe public",
    "privateGroup" : "Groupe Privé",
    "coverImage" : "Couverture de groupe",
    "members" : "Membres",
    "posts" : "Articles",
    "admin" : "Administrateur",
    "settings" : "PARAMÈTRES",
    "inviteMembers" : "INVITER LES MEMBRES",
    "answerQuestions" : "Répondre aux questions",
    "toJoin" : "pour rejoindre {name}",
    "leaveGroup" : "Quitter le groupe",
    "leaveGroupConfirmMessage" : "Êtes-vous certain de vouloir quitter ce groupe? Vous perdrez l'accès à tous les cours payants, aux événements payants et à votre adhésion au groupe.",
    "leaveGroupSuccessTitle" : "Vous avez quitté le groupe",
    "leaveGroupSuccessMessage" : "Vous avez quitté le groupe avec succès.",
    "leaveGroupErrorTitle" : "Impossible de quitter le groupe",
    "leaveGroupErrorMessage" : "Une erreur s'est produite lors de la sortie du groupe. Veuillez réessayer.",
    "groupActions" : "Actions de groupe",
    "changeRole" : "Changement de rôle",
    "removeFromGroup" : "Extraire de la Collection",
    "contributor" : "Contributeur",
    "membershipAnswers" : "Réponses d'adhésion",
    "unbanMember" : "Débannir un membre",
    "banFromGroup" : "Ban du groupe",
    "requestedOn" : "Demandé le",
    "invitedOn" : "Invité le",
    "joinedOn" : "Rejoint",
    "noMembersFound" : "Aucun membre trouvé.",
    "youAreAllCaughtUp" : "Vous êtes pris en charge",
    "banUserConfirmation" : "Êtes-vous sûr de vouloir bannir cet utilisateur du groupe?",
    "deleteContentCheckbox" : "Supprimer tout ce",
    "active" : "Actif",
    "admins" : "Admins",
    "contributors" : "Contributeurs",
    "requested" : "Demandé",
    "banned" : "Interdits",
    "invited" : "Invité",
    "paymentReceived" : "Paiement reçu",
    "paymentInitiated" : "Paiement initialisé",
    "answeredQuestions" : "Questions répondues",
    "answeredQuestionsMessage" : "répondu à la question suivante pour rejoindre",
    "darkMode" : "Mode sombre",
    "darkModeMessage" : "Modifier l'apparence de la communauté pour réduire l'éblouissement et reposer vos yeux.",
    "accessGranted" : "Accès accordé : commencez votre aventure d'apprentissage.",
    "stepIntoAction" : "Passez à l'action! Collaborons et amusons-nous.",
    "viewMembersAndMemberDetails" : "Voir les membres et les détails des membres",
    "reviewContentReportsAndMore" : "Consultez les rapports de contenu et plus encore",
    "toReview" : "À examiner",
    "switchToOtherGroups" : "Passer à d'autres groupes",
    "placeholders" : {
      "yourAnswer" : "Votre réponse"
    },
    "notifications" : {
      "userBanned" : "L’utilisateur a été banni de la Collection avec succès",
      "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard"
    },
    "membershipSettings" : "Paramètres d'abonnement",
    "paymentFailed" : "Le paiement a échoué!",
    "paymentFailedMessage" : "Paiement échoué, votre demande de rejoindre le groupe a été refusée.",
    "gamification" : {
      "addRewards" : "Ajouter des récompenses",
      "title" : "Titre",
      "description" : "Ajoute une description",
      "textbox" : "Zone de texte",
      "singleSelect" : "Sélection individuelle",
      "multipleSelect" : "Sélection multiple",
      "question" : "Question",
      "validations" : {
        "titleRequired" : "Veuillez indiquer le titre",
        "descriptionRequired" : "S'il vous plaît donner une description",
        "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard",
        "updatedRewards" : "Récompenses mises à jour"
      },
      "settings" : {
        "updatedRewards" : "Récompenses mises à jour"
      }
    },
    "customCode" : {
      "advanced" : "Avancé",
      "testPreview" : "Aperçu du test",
      "enableConfirmationMessage" : "Activez-le uniquement une fois que vous avez vérifié l'aperçu du test",
      "testPreviewMessage" : "Cela ouvrira un nouvel onglet avec l'aperçu du test de votre communauté. Vous pouvez l'utiliser pour vérifier si votre Code personnalisé fonctionne comme prévu.",
      "liveMode" : "Mode En direct",
      "customJS" : "JS Personnalisé",
      "customCSS" : "CSS Personnalisé",
      "trackingCode" : "Code de suivi",
      "headerCode" : "Code En-tête",
      "footerCode" : "Code de Pied de page"
    },
    "branding" : {
      "brandYourGroup" : "Vous pouvez  marquer votre Collection selon votre choix ici",
      "updateBranding" : "Mise à jour de l’image de marque",
      "clickToUploadFavicon" : "Cliquez pour télécharger le Favicon",
      "dragAndDropFavicon" : "Traînez et déposez un {types} (format d'image 1:1)",
      "clickToUploadCover" : "Cliquez pour télécharger la couverture",
      "dragAndDropCover" : "Trainez et déposez un {types} (format d'image 16:9)",
      "clickToUploadLogo" : "Cliquez pour télécharger le Logo de la Collection",
      "dragAndDropLogo" : "Traînez et déposez un {types} (format d'image 1:1)",
      "aspectRatioMustBe1To1" : "Le rapport d’aspect de la photo doit être de 1:1",
      "aspectRatioMustBe16To9" : "Le rapport d’aspect de la photo doit être de 16:9",
      "favicon" : "Favicon",
      "coverImage" : "Image de couverture",
      "logo" : "Logo",
      "invalidFileFormat" : "Oups! Format/Type de fichier non valide.",
      "pleaseUploadImageType" : "Types de fichier pris en charge : {types}"
    },
    "groupAppearance" : {
      "description" : "Vous pouvez configurer votre apparence de groupe selon vos choix ici",
      "slug" : "Mise à jour votre apparence de groupe ici",
      "colorMode" : "Mode Couleur",
      "previewTheLook" : "Voir un aperçu de la manière dont votre groupe apparaîtra in mode Léger et Foncé",
      "light" : "Léger",
      "dark" : "Foncé",
      "communityTheme" : "Thème de la communauté",
      "customTheme" : "Thème Personnalisé",
      "windowGradient" : "Gradient de la Fenêtre",
      "applyGradientColorsToYourSidebarAndTopbar" : "Applique des couleurs de Gradient à votre barre latérale et à votre barre supérieure",
      "labels" : {
        "sidebarBackground" : "Contexte de la barre latérale",
        "primary" : "PRIMAIRE",
        "secondary" : "Seconde",
        "tertiary" : "Terrible",
        "surface" : "SUPERPOSITION",
        "fontPrimary" : "Police primaire",
        "fontSecondary" : "Police supplémentaire",
        "fill" : "Remplir de la Couleur",
        "border" : "Bordure",
        "error" : "Erreur",
        "background" : "Contexte",
        "option" : "Option"
      },
      "customThemes" : {
        "default" : "Par défaut",
        "zestyCitrus" : "D'accord",
        "royalVelvet" : "Ellipses",
        "sunnyDelight" : "Coucher de soleil",
        "lushMeadow" : "Mis à jour",
        "azureDreams" : "Remplissage de l'arrière-plan",
        "bubblegumBliss" : "Fois",
        "ivoryWhisper" : "chuchoté d'origine",
        "midnightDeep" : "Propriétaire"
      },
      "unsavedChanges" : "Flux de travail non enregistré",
      "unsavedChangesMessage" : "Vous ont"
    },
    "promotionalLinks" : {
      "promotionalLinks" : "Liens promotionnels",
      "createPromotionalLinkDescription" : "Créer des Liens promotionnels pour votre Collection",
      "addPromotionalLink" : "Ajouter un lien",
      "deleteLink" : "Supprimer le lien",
      "deleteLinkConfirmation" : "Êtes-vous sûr de vouloir supprimer ce lien ?",
      "labels" : {
        "description" : "Description",
        "url" : "URL",
        "private" : "Privé",
        "privateLinksDescription" : "Les liens privés ne sont visibles que pour les membres de la Collection"
      },
      "placeholders" : {
        "enterLinkDescription" : "Saisissez la description du lien",
        "enterLinkURL" : "Entrez l'URL du lien"
      },
      "addPromotionalLinkDescription" : "Créer des liens pour votre groupe",
      "ariaLabels" : {
        "editLink" : "Modifier le lien",
        "deleteLink" : "Supprimer le lien"
      }
    },
    "membershipQuestions" : {
      "addQuestion" : "Ajouter une question",
      "editQuestion" : "Modifier la question",
      "editLevelName" : "Modifier le nom du niveau",
      "addOption" : "Ajouter une option",
      "level" : "Niveau",
      "name" : "Nom",
      "addMembersQuestionsDescription" : "Ajouter des questions aux membres à poser lorsqu'ils demandent l'accès à votre groupe",
      "enableMembershipQuestions" : "Activer les questions d'abonnement",
      "membershipQuestions" : "Questions sur l’abonnement",
      "deleteQuestion" : "Supprimer la question",
      "deleteQuestionConfirmation" : "Voulez-vous vraiment supprimer cette question?",
      "modalDescription" : "Add a custom question or select a field from your CRM contact fields.",
      "searchPlaceholder" : "Search by name",
      "loadFieldsErrorTitle" : "Unable to load contact custom fields",
      "loadFieldsErrorDescription" : "Please try again or switch back to a custom question.",
      "noFieldsFoundTitle" : "Aucun champ correspondant",
      "noFieldsFoundDescription" : "Essayez une autre recherche ou ajoutez une question personnalisée.",
      "customFieldEditTooltip" : "Les champs personnalisés ne peuvent pas être modifiés",
      "tabs" : {
        "addQuestion" : "Add Question",
        "contactCustomFields" : "Contact Custom Fields"
      },
      "labels" : {
        "textBox" : "Zone de texte",
        "singleSelect" : "Sélection individuelle",
        "multipleSelect" : "Sélection multiple",
        "enableMembershipQuestions" : "Ajouter au moins une Question aux questions d'adhésion actives"
      },
      "validations" : {
        "questionRequired" : "Veuillez saisir une question",
        "answerOptionsRequired" : "Un minimum de deux Options est Obligatoire, et elles doivent être uniques",
        "somethingWentWrong" : "Une erreur s'est produite! Veuillez réessayer plus tard",
        "updatedQuestions" : "Questions mises à jour sur l'abonnement à la Collection",
        "levelNameRequired" : "Veuillez saisir le nom du niveau",
        "updatedLevelName" : "Nom du niveau mis à jour"
      },
      "placeholders" : {
        "enterLevelName" : "Nom du niveau",
        "selectOne" : "Sélectionnez une option",
        "keepItShort" : "gardez les choses courtes..",
        "exampleOffer" : "par exemple 10 %."
      },
      "privacyNotice" : "Je comprends que mon",
      "ariaLabels" : {
        "editQuestion" : "Modifier la question",
        "deleteQuestion" : "Supprimer la question"
      }
    },
    "gamificationAndRewards" : {
      "title" : "Personnaliser les Couches et les récompenses",
      "description" : "Personnalisez les noms de niveau et ajoutez des récompenses pour un meilleur engagement des membres",
      "gamification" : "Gamification",
      "rewards" : "Récompenses",
      "addRewards" : "Ajouter une récompense",
      "ariaLabels" : {
        "toggleGamification" : "Activer/désactiver les options de gamification"
      }
    },
    "invitations" : {
      "invitationSentSuccessfully" : "Invitation envoyée avec succès",
      "invitationSentSuccessfullyDescription" : "Invitation envoyée à {email}",
      "shareGroupLink" : "Partager le lien de votre groupe",
      "inviteMember" : "Inviter un membre",
      "inviteMemberDescription" : "Renforcez votre communauté en invitant un nouveau membre",
      "inviteViaEmail" : "Invitation via Email",
      "invitedMembersWillBeAutoApproved" : "Les membres invités seront automatiquement acceptés pour rejoindre le groupe.",
      "sendInvite" : "ENVOYER UNE INVITATION",
      "permissionDenied" : "Vous n'avez pas l'autorisation d'invitations de membres. Veuillez Contact votre administrateur.",
      "notifications" : {
        "INVITATION_CREATE_UNAUTHORIZED" : "Vous n'avez pas l'autorisation d'envoyer des invitations.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE" : "Ce groupe n'autorise pas les membres à inviter d'autres personnes.",
        "INVITATION_CREATE_ALREADY_INVITED" : "Cet utilisateur a déjà été invité.",
        "INVITATION_CREATE_ALREADY_MEMBER" : "Cet utilisateur est déjà membre du groupe."
      },
      "labels" : {
        "giveAdministrativePrivileges" : "Accorder des privilèges administratifs",
        "giveAdministrativePrivilegesDescription" : "Activer ce membre à effectuer toutes les actions administratives",
        "name" : "Nom",
        "email" : "Courriel",
        "nameLabel" : "Nom",
        "emailLabel" : "Courriel"
      },
      "placeholders" : {
        "enterName" : "Saisis le nom",
        "enterEmail" : "Entrez le courriel"
      }
    },
    "groupDetails" : {
      "updateGroupDetails" : "Mettre à jour les Info de la Collection",
      "updateGroupDetailsDescription" : "Mettez à jour les détails de votre Collection ici",
      "slugNotAvailable" : "Limace de collection non disponible",
      "description" : "Expliquer la nature des discussions qui auront lieu au sein du groupe",
      "publicDescription" : "Tout le monde peut voir les publications de la Collection et les autres membres de la Collection",
      "privateDescription" : "Seuls les membres peuvent voir les publications de la Collection et les autres membres de la Collection",
      "accessibleFromSwitcher" : "Accessible depuis le commutateur",
      "accessibleFromSwitcherDescription" : "Votre Collection sera visible pour les non-Membres de la Collection dans le Commutateur",
      "allowMembersToInvite" : "Membres actifs pour invitations de nouveaux membres",
      "allowMembersToInviteDescription" : "Cacher l'invitation du bouton pour les membres lorsqu'ils sont transformés en Handicapés. Les membres peuvent invitations uniquement. Si ce n'est activé.",
      "showMandatoryInfoModal" : "Afficher la fenêtre modale obligatoire du profil",
      "showMandatoryInfoModalDescription" : "Quand cette option est activée, les membres sont invités à finir les détails de leur profil lorsqu'ils rejoignent le groupe.",
      "slug" : "Limace de groupe",
      "discovery" : {
        "title" : "Découverte",
        "description" : "Faites-vous découvrir par millions d'Utilisateurs actifs. La Collection sera visible sur la page Découvrir dès que vous aurez plus de 10 Membres.",
        "discoverChannels" : "Découvrir des canaux",
        "joinGroupToExploreAllChannels" : "Le groupe pour visiter tout le canal",
        "categoryIsUsedOnlyOnGokollab" : "La catégorie est utilisée uniquement sur Gokollab",
        "categoryAutomaticallySuggested" : "La catégorie est automatiquement recommandée par l'IA en fonction du titre et de la description de votre groupe. Pour une suggestion la plus précise, assurez-vous que les détails de votre groupe reflètent clairement son objectif et ses thèmes.",
        "categoryRefreshLimited" : "Le rafraîchissement des catégories est limité à une fois toutes les 24 heures"
      },
      "placeholders" : {
        "description" : "Saisissez une brève description"
      },
      "validations" : {
        "nameRequired" : "Veuillez saisir un nom de groupe valide!",
        "slugRequired" : "Veuillez saisir un slug de groupe valide!",
        "specialCharacterNotSupported" : "Les caractères spéciaux ne sont pas pris en charge",
        "descriptionRequired" : "La description du groupe est requise!",
        "emailRequired" : "Veuillez saisir une adresse courriel valide!",
        "fullNameRequired" : "Veuillez saisir un nom valide!"
      },
      "labels" : {
        "groupName" : "Nom du Groupe"
      }
    },
    "subscriptions" : {
      "manageSubscriptions" : "Gérer votre abonnement",
      "viewAndManageGroupSubscriptions" : "Voir et gérer l'abonnement du groupe",
      "paymentIntegrationMissingMessage" : "Veuillez intégrer les paiements in Emplacement pour le groupe Activer Payé",
      "price" : "Prix",
      "currency" : "Monnaie",
      "priceDisplay" : "{symbol}{price}{suffix}",
      "priceInterval" : "/{interval}",
      "oneTime" : " Une Date",
      "priceDeletedAlert" : "Paiement",
      "intervals" : {
        "month" : "Mois",
        "year" : "Année",
        "week" : "Semaine",
        "day" : "Jour"
      },
      "addNewPrice" : "Ajouter du nouveau prix",
      "editPrice" : "Modifier le Prix",
      "addPrice" : "Ajouter un Prix",
      "subscriptionType" : {
        "recurring" : "Récurrent",
        "oneTime" : "Une Date"
      },
      "billingPeriod" : {
        "monthly" : "Mensuel",
        "annually" : "Annuel",
        "weekly" : "Hebdomadaire",
        "daily" : "Quotidiennement"
      },
      "ariaLabels" : {
        "freeMembership" : "Bouton radio d’adhésion gratuit",
        "paidMembership" : "Bouton radio d’adhésion payante"
      }
    },
    "menuOptions" : {
      "details" : "Détails",
      "subscriptions" : "Abandonner",
      "branding" : "Image de marque",
      "themes" : "Thème",
      "tabsConfiguration" : "Afficher / Masquer les onglets",
      "membershipQuestions" : "Question Adhésion",
      "gamificationAndRewards" : "Gamification et rétroaction",
      "links" : "Liens",
      "newsletter" : "Bulletin d’information",
      "reportedContent" : "Contenu rapporté",
      "discovery" : "Découvrir",
      "import" : "Importer"
    },
    "newsletter" : {
      "title" : "Bulletin d’information",
      "subheading" : "Votre résumé de communauté",
      "frequency" : "Fréquence du bulletin d'information",
      "description" : "Un résumé des publications populaires, de l'activité des membres et des occurrences de ce groupe",
      "time" : "Heure",
      "weekday" : "Jour de semaine",
      "monthDay" : "Jour du mois",
      "lastDay" : "Dernier jour",
      "selectFrequency" : "Sélectionnez la fréquence",
      "frequencies" : {
        "off" : "Désactivé",
        "daily" : "Quotidien",
        "weekly" : "Hebdomadaire",
        "biweekly" : "Bimensuel",
        "monthly" : "Mensuel"
      }
    },
    "tabConfiguration" : {
      "title" : "Afficher / Masquer les onglets",
      "description" : "Contrôlez quels onglets apparaissent pour votre communauté. Activez ou désactivez chaque onglet pour offrir une expérience ciblée et simplifiée à vos membres.",
      "discussionDescription" : "Commencez ou rejoignez des conversations pour partager des mises à jour, des idées et des réflexions avec votre communauté.",
      "learningDescription" : "Créez et gérez des cours qui aident les membres à acquérir de nouvelles compétences ou connaissances.",
      "eventsDescription" : "Planifiez, organisez et visualisez les sessions, les ateliers ou les événements communautaires à venir.",
      "leaderboardDescription" : "Mettez en valeur les membres les plus performants et encouragez un engagement sain grâce à des classements.",
      "membersDescription" : "Gérer tous les membres et leurs rôles. Cet onglet reste visible pour les administrateurs même lorsqu'il est désactivé, de sorte que la gestion des membres est toujours accessible.",
      "aboutDescription" : "Présentez le but, les valeurs et l'histoire de votre communauté pour faciliter les échanges entre ses membres.",
      "discussionTooltip" : "La discussion est un onglet essentiel de la communauté : elle ne peut pas être désactivée.",
      "aboutTooltip" : "L'onglet « À propos » est nécessaire pour fournir des renseignements essentiels sur la communauté : il ne peut pas être désactivé."
    },
    "groupSettings" : {
      "groupSettings" : "Réglages du Groupe",
      "changeGroupType" : "Changement du Type de Groupe",
      "changeGroupTypeDescriptionPrivateToPublic" : "dynamique pour un groupe Public signifie que tout en attente sera automatiquement accepté et le contenu sera visible publiquement. Poursuivre?",
      "changeGroupTypeDescriptionPublicToPrivate" : "Envoyez un message au groupe privé, ce qui signifie que les nouveaux membres doivent être approuvés et le contenu reste en l'attente jusqu'à ce qu'ils soient acceptés. Poursuivre?",
      "changeGroupTypeConfirmation" : "Êtes-vous sûr de vouloir changer le Type de groupe ?",
      "changeGroupTheme" : "Changement de Thème de Groupe",
      "changeGroupThemeDescription" : "Cela modifiera le changement pour tout le groupe. Êtes-vous sûr de vouloir changer de groupe?",
      "updatedGroupDetails" : "Détails du Groupe Mise à jour",
      "unableToSaveDetails" : "Oups! Impossible d'inclure des détails.",
      "groupNameIsRequired" : "Le Nom du groupe est obligatoire",
      "groupDescriptionIsRequired" : "Description du groupe est obligatoire",
      "groupSlugIsRequired" : "Le groupe Limace est obligatoire",
      "groupSlugMustContainOnly" : "Le groupe Limace doit contenir uniquement des lettres de minutes, de .",
      "groupSlugAlreadyExists" : "Le Limace du Groupe existe déjà. Veuillez utiliser un autre Limace car ce dernier est déjà pris",
      "groupSlugRestricted" : "Ce segment d’URL correspond à l'un de nos mots-clés restreints pour les liens communautaires. Veuillez utiliser un autre segment d’URL",
      "pleaseTryAgainLater" : "Veuillez réessayer plus tard",
      "unsavedChangesMessage" : "Vous avez non enregistré Groupe Limace, êtes-vous sûr de vouloir les annuler?"
    },
    "import" : {
      "header" : "Importer les Membres du Groupe et leur Contenu",
      "credentialDescription" : "Entrez votre autorisation pour importer de votre groupe et de leur contenu",
      "csvUploadDescription" : "Sélectionner des .csv Envoyez un message au contact",
      "loginFailed" : "Vous avez saisi un mot de password non valide. Veuillez réessayer.",
      "proceedWithImport" : "Poursuivre avec Importer?",
      "iAgree" : "J'accepte",
      "importTerms" : "en cliquant sur « J'accepte », vous confirmez et reconnaissez que vous nous avez engagé en tant qu'accord indépendant pour fournir ServicesServices . Les Services comprennent le transfert de certaines données, des détails, du contenu, des Info Vous représentez et assurez-vous que (i) Vous êtes le propriétaire de l' Info in le compte de plateforme de diffusion, (secondaire) Vous avez les autorisations pour nous attribuer l'accès au compte de plateforme de diffusion pour l'intention de fournir des Services et (hui) la transfert de l' Info ne code pas les autorisations intellectuelles du tiers. Vous acceptez de nous indemniser, de nous défendre et de nous dégager de toute responsabilité pour toute réclamation de tiers découlant de votre violation des réponses et garanties ci-dessus.",
      "pleaseDownloadCSV" : "Veuillez télécharger le fichier .csv",
      "step01" : "Étape 01-",
      "step02" : "Étape 02-",
      "uploadCSV" : "Téléverser votre .csv",
      "step01Description" : "in ou mettre à jour toutes les informations manquantes pour les membres du groupe, telles que Gmail, Prénom, etc. Assurez-vous que le CSV est téléchargé in",
      "thisTemplate" : "ce modèle",
      "importCSV" : "Importer . CSV",
      "reSyncData" : "Resynchronisez vos données avant de télécharger.",
      "refreshUserList" : "Rafraîchir la liste de l'utilisateur",
      "reSyncDataDescription" : "Si de nouveaux utilisateurs sont ajoutés in le service, nous vous recommandons de rafraîchir votre liste et de télécharger le CSV.",
      "pleaseDontChangeProfileSlug" : "Veuillez ne pas modifier de profil d'instantané.",
      "selectFile" : "Sélectionner un Fichier",
      "changeFile" : "Changement de Fichier",
      "importMembersFailedText" : "Cela peut être dû au fait qu'ils sont manquants. Veuillez vérifier votre importation et réessayer avec des adresses courriel valides pour ces membres.",
      "upload" : "Téléverser",
      "tryAgain" : "Réessayer",
      "importerAnotherGroup" : "Start New Import",
      "syncAllPosts" : "Synchronisation de votre partage et de votre commentaire",
      "membersCouldNotBeAdded" : "Les membres n'ont pas pu être ajoutés au groupe.",
      "importMembersSuccess" : "Nous avons envoyé un courriel pour présenter des membres du groupe, confirmant leur adhésion in groupe et leur offrant des détails. Cela aide à s' assurer que tous les membres sont mis à jour et peuvent accéder au groupe efficacement.",
      "importMembersAdded" : "Les membres ont été ajoutés avec succès au groupe",
      "postsNotSynced" : "Les messages restants n'ont pas pu être synchronisés avec le groupe. Cela peut être dû au fait que les utilisateurs de Partager n'ont pas été importé avec succès.",
      "migrationFailed" : "Échec de la transition. Veuillez réessayer.",
      "migrationCompleted" : "Terme de flux de travail!",
      "migrationInProgress" : "Migration en cours",
      "createProfile" : "Créer un profil",
      "enterCredentials" : "Entrez vos identifiants",
      "uploadingInProgress" : "Téléverser in cours!",
      "listMembers" : "La liste des membres est en cours",
      "downloaded" : "Télécharger",
      "uploaded" : "téléchargé",
      "listPostsDownloaded" : "La liste des publications est Télécharger.",
      "listPostsDownloading" : "La liste des publications est en cours de téléchargement.",
      "posts" : "poste",
      "members" : "Membres",
      "imported" : "importé",
      "step1" : "Étape 1",
      "step2" : "Étape 2",
      "step1Description" : "Créer un profil de membre in le groupe .",
      "step1Description2" : "(y compris le Nom, l'Id de Courriel et le mot de passe)",
      "step2Description" : "Saisir l'Certificat de la session",
      "skoolUrlPlaceholder" : "Saisissez l'URL du groupe de votre Skool",
      "emailPlaceholder" : "Entrez l'Id de Courriel de votre Id de l'équipe",
      "emailTooltip" : "Saisissez les membres du courriel avec votre compte de textos",
      "passwordPlaceholder" : "Entrez le mot de passe de votre équipe",
      "confirm" : "Confirme",
      "validation" : {
        "skoolUrl" : "Veuillez saisir une URL de l'équipe valide",
        "email" : "Le courriel est obligatoire",
        "password" : "Le mot de passe est obligatoire"
      }
    },
    "approved" : "Accepté",
    "pending" : "En attente",
    "rejected" : "Refusé"
  },
  "invitations" : {
    "intent" : "Aidez cette communauté à grandir!",
    "cancelInvitation" : "Annuler l'invitation",
    "inviteMembers" : "Invitez les membres à collaborer sur cette communauté.",
    "inviteLink" : "Lien d'invitation",
    "invitationLink" : "lien d'invitation",
    "buildYourCommunity" : "Bâtissez votre communauté!",
    "inviteMembersToCollaborate" : "Vous avez créé une nouvelle communauté! Invitez vos membres à collaborer dans cette communauté.",
    "invite" : "Inviter",
    "basicInformation" : "Informations de base",
    "permissions" : "Autorisations"
  },
  "createPost" : {
    "title" : "Créer un nouvel article de blogue",
    "placeholder" : "Qu’est-ce que vous avez en tête",
    "liveStream" : "Diffusion en direct",
    "slug" : "Lien URL de l'article de blogue",
    "titleHelp" : "La légende, la description et l'image seront utilisés pour la balise méta SEO",
    "nameLabel" : "Légende de l'article de blogue",
    "nameValidation" : "Une légende est requise",
    "descriptionLabel" : "Description de la publication",
    "descriptionHelp" : "Donnez une brève description pour que les spectateurs puissent avoir un aperçu de la publication. Fonctionne mieux entre 100 et 250 caractères",
    "descriptionValidation" : "Une description est requise",
    "createLabel" : "Créer une publication",
    "image" : "Photo de l'article de blogue",
    "imageDescription" : "La taille recommandée est de 600 px * 400 px",
    "notificationTitle" : "Article de blogue créé",
    "notificationErrorTitle" : "Impossible de générer un article de blogue",
    "postingIn" : "in",
    "editingIn" : "in"
  },
  "post" : {
    "downloadRecording" : "Télécharger l’Enregistrement",
    "deletePost" : "Supprimer le message",
    "reportPost" : "Signaler un message",
    "editPost" : "Modifier le message",
    "createPost" : "Créer une publication",
    "publish" : "Poste",
    "publishPost" : "Publier un message",
    "addChannel" : "Ajouter une chaîne",
    "selectChannel" : "Veuillez sélectionner la chaîne",
    "addLink" : "Ajouter un lien",
    "removeLink" : "Extraire le Lien",
    "update" : "Mise à jour",
    "unsavedChanges" : "Vous avez des modifications non enregistrées",
    "unsavedChangesMessage" : "Vos modifications non enregistrées seront perdues. Voulez-vous quand même continuer?",
    "unpinFromChannel" : "Unpin",
    "unpinFromHome" : "Unpin",
    "deletePostConfirmation" : "Êtes-vous sûr de vouloir supprimer ce billet?",
    "reportPostConfirmation" : "Voulez-vous vraiment signaler cette publication?",
    "postNotFound" : "Poste introuvable",
    "postNotFoundMessage" : "Le Partager que vous essayez de voir est soit Supprimé, soit n'existe pas.",
    "loadMoreComments" : "Charger plus de commentaires",
    "channelNotFound" : "Chaîne non trouvée",
    "isCurrentlyLive" : "est maintenant en direct",
    "isStartingNow" : "commence maintenant",
    "isHappeningInMinutes" : "se passe dans {minutes} minutes",
    "isHappeningInHours" : "se produit in {hours} l'heure | se produit in {hours} l’heure",
    "publicChannel" : "Chaîne publique",
    "privateChannel" : "Canal privé",
    "featured" : "En vedette",
    "featuredAbout" : "À propos de Vedette",
    "noPostsFound" : "Aucun publication trouvée",
    "pinInfo" : "Vous pouvez épingler des éléments à afficher en haut de la Collection, y compris des publications, des règles et des hashtags.",
    "pinInfoEveryone" : "Tout le monde dans le groupe verra ces éléments.",
    "pinInfoRemainVisible" : "Les objets épinglés restent visibles jusqu'à ce que vous les déépinglez.",
    "pinInfoNewestItem" : "Au fur et à mesure que vous épinglez des articles, l'élément le plus récent apparaît en haut de la liste.",
    "onlyVisibleToAdmins" : "Visible uniquement par les administrateurs",
    "featuredAboutDescription" : "Vos administrateurs ont épinglé ces éléments pour que la Collection puisse les voir.",
    "channelNotFoundMessage" : "Vous n'êtes plus membre de la chaîne à laquelle vous essayez d'accéder ou la chaîne a été supprimée.",
    "notifications" : {
      "unpinned" : "Non épinglé!",
      "pinned" : "Gagné!",
      "reported" : "Le message a été signalé!",
      "error" : "Une erreur s'est produite!",
      "isCommentDisabled" : "Commentaires désactivés!",
      "isCommentEnabled" : "Commentaires activés!",
      "createPost" : "Erreur lors de la création de la publication",
      "editPost" : "Erreur lors de l'édition de la publication",
      "POST_CONTENT_SIZE_EXCEEDED" : "Le contenu de la publication est trop volumineux. Veuillez réduire la taille et réessayer."
    },
    "movePostToChannel" : "Déplacer vers le Canal",
    "pin" : "NIP",
    "pinToHome" : "NIP à la Accueil",
    "pinToChannel" : "NIP au Canal",
    "whatIsYourTitle" : "Quel est votre titre?",
    "postMovedToChannel" : "Partager déplacé dans {channelName} canal",
    "upcomingEvent" : "Événement à venir",
    "turnOffCommenting" : "Désactiver les commentaires",
    "enableComments" : "Activer les commentaires",
    "disableComments" : "Désactiver les commentaires",
    "moveToPrivateChannelConfirmation" : {
      "title" : "Passer à un canal privé",
      "message" : "Vous êtes sur le point de déplacer cette publication vers un canal privé. Seuls les membres de ce canal privé pourront le voir. Voulez-vous continuer?"
    },
    "onlyAdminsCanPost" : "Seuls les administrateurs de la communauté peuvent publier dans ce canal."
  },
  "reaction" : {
    "noLikes" : "Pas de mentions « j'aime »",
    "andOthers" : "et {count} autres"
  },
  "UIConfirmation" : {
    "privateGroup" : "Cette Collection est privée",
    "privateGroupMessage" : "Vous devez être membre de cette Collection pour accéder à l'information spécifique au groupe. Veuillez demander l'accès en cliquant sur le bouton Rejoindre la Collection."
  },
  "notifications" : {
    "noNotificationsYet" : "Aucune notification pour le moment",
    "whenYouGetNotifications" : "Quand vous recevez des notifications, elles s'afficheront ici",
    "markAllAsRead" : "Marquer tout comme lu",
    "notifications" : "Notifications",
    "all" : "Tous",
    "unread" : "Non lu",
    "checkNotifications" : "Ouvrir une session pour vérifier les notifications",
    "noNotifications" : "Aucune notification!",
    "redirectedFromOldSlug" : {
      "title" : "Vous avez été redirigé vers le lien mis à jour de la communauté",
      "content" : "Cela a été fait pour optimiser la performance SEO de cette communauté. Veuillez mettre à jour vos signets avec cette nouvelle URL."
    }
  },
  "joinGroupModal" : {
    "wahoo" : "Wahoo! 🎉, demande envoyée avec succès",
    "reviewRequestSoon" : "Nos administrateurs de groupe examineront bientôt votre demande. Soyez patient et nous vous informerons une fois votre adhésion approuvée.",
    "nonMemberMessage" : "Vous devez faire partie de cette Collection pour aimer et commenter les publications",
    "subscribeFor" : "Abonnez-vous pour",
    "joinGroup" : "REJOINDRE LE GROUPE",
    "membershipPending" : "Adhésion en attente",
    "viewMembershipAnswers" : "Voir les réponses des Adhésion",
    "requested" : "Demandé",
    "dayFreeTrial" : "Jour d'essai gratuit",
    "notPartOfGroup" : "Vous ne faites pas encore partie de ce groupe, vos demandes d'adhésion sont in avis. Une fois qu'un administrateur accepte vos demandes, nous vous enverrons une notification",
    "pleaseAnswerMembershipQuestions" : "Veuillez répondre aux questions d'adhésion pour associer ce groupe",
    "answerQuestions" : "Répondre aux questions d’adhésion"
  },
  "userProfilePopover" : {
    "active" : "Actif",
    "longAgo" : "il y a longtemps",
    "chatDisabled" : "Cet utilisateur a désactivé son chat",
    "pointsToLevelUp" : "Points pour monter de niveau",
    "profile" : "Profil",
    "deletedUser" : "Utilisateur supprimé",
    "joined" : "Rejoint",
    "contributions" : "Contributions"
  },
  "courses" : {
    "by" : "Par",
    "free" : "Gratuit",
    "unknownInstructor" : "Instructeur Inconnu",
    "courseRestricted" : "Ce cours est réservé",
    "courseDeleted" : "Ce cours a été supprimé",
    "noMatchingCourseFound" : "Aucun cours correspondant n'a été trouvé",
    "addCourse" : "Ajouter un cours",
    "updateCourse" : "Mettre à jour le cours",
    "access" : "Tous les membres ont accès",
    "unableToAddCourse" : "Oups! Impossible d'ajouter le cours.",
    "pleaseTryAgainLater" : "Veuillez réessayer plus tard",
    "paymentIntegrationMissing" : "Oups! L'intégration du paiement est manquante",
    "paymentIntegrationMissingMessage" : "Veuillez intégrer les paiements dans l'emplacement pour activer les cours payants",
    "course" : "Cours",
    "courseInThisGroup" : "un cours existant dans ce groupe",
    "courseLinkCopied" : "Lien du cours copié!",
    "buyNow" : "ACHETEZ MAINTENANT",
    "locked" : "UTILISATEUR",
    "buyCourse" : "ACHETER UN COURS",
    "open" : "OUVERT",
    "moveCard" : "Déplacer la carte",
    "courseViewMessage" : "Vous devez faire partie de cette Collection pour voir les Cours.",
    "deleteCourse" : "Supprimer le cours",
    "deleteCourseConfirmation" : "Êtes-vous sûr de vouloir supprimer ce cours?",
    "courseAccessNotGranted" : "Accès aux cours non accordé",
    "courseAccessNotGrantedMessage" : "Nous travaillons actuellement à vous accorder l'accès au cours. Veuillez actualiser la page et réessayer dans une minute.",
    "autoRenewsAfter" : "Se renouvelle automatiquement après",
    "oneTimePayment" : "Paiement unique",
    "emptyCoursesMessage" : "Apparence d'une ville fantôme. Rien à voir ici!",
    "updatedSuccessfully" : "Mise à jour avec succès",
    "addedSuccessfully" : "Cours ajouté avec succès",
    "createCourse" : "Créer un nouveau cours",
    "emptyCourseLibrary" : "Votre bibliothèque de cours est vide!",
    "createdOutsideGokollabMessage" : "Cette communauté a été créée en dehors de Gokollab et a été rendue visible. Pour créer de nouveaux cours, veuillez vous connecter à la communauté depuis sa plateforme source",
    "createCourseOnGokollabMessage" : "Créez un nouveau cours sur Gokollab pour le rendre accessible aux membres de votre communauté.",
    "or" : "ou",
    "createNewOne" : "crée-en un nouveau",
    "labels" : {
      "selectCourse" : "Sélectionner un cours",
      "courseVisibility" : "Visibilité pour le cours",
      "courseAccess" : "Accès aux cours",
      "coursePrice" : "Prix du cours",
      "subscriptionType" : "Type d'abonnement",
      "billingPeriod" : "Période de facturation",
      "testMode" : "Mode essai",
      "turnOnTestPayments" : "Activer les paiements de test à l'aide d'une carte de test",
      "currency" : "Monnaie",
      "trialDays" : "Jours d'essai",
      "recurring" : "Récurrent",
      "free" : "Gratuit",
      "oneTime" : "Une Date",
      "refresh" : "Rafraîchir",
      "accessStartsAtDay" : "Accès commence le Jour",
      "maximumYouCanEnterIs365" : "Le Max de votre saisie est de 365",
      "allMembers" : "Tous les membres",
      "levelUnlock" : "Dépannage",
      "buyNow" : "Acheter maintenant",
      "timeUnlock" : "Date non verrouillé",
      "gamificationLevel" : "Gamification",
      "privateChannel" : "Canal Privé",
      "private" : "Privé",
      "marketingChannel" : "Marketing des Canal",
      "selectCurrency" : "Sélectionner la devise"
    },
    "placeholders" : {
      "enterPrice" : "Entrez le prix",
      "enterTrialDays" : "Entrez les jours d'essai",
      "selectCurrency" : "Sélectionnez une option",
      "selectBillingPeriod" : "Sélectionnez une option",
      "billingPeriod" : "Sélectionnez la période de facturation"
    },
    "validations" : {
      "validPrice" : "Veuillez saisir un prix valide",
      "required" : "Veuillez sélectionner un cours",
      "validMembershipPrice" : "Veuillez saisir un prix d'adhésion valide",
      "validTrialDays" : "Veuillez saisir des jours d'essai valides",
      "requiredSubscriptionType" : "Veuillez sélectionner le type d'abonnement",
      "courseVisibility" : "Veuillez sélectionner la visite de cours",
      "requiredGamificationLevel" : "Veuillez sélectionner le Gamification",
      "requiredPrivateChannel" : "Veuillez sélectionner le canal privé",
      "validAccessStartDay" : "Veuillez saisir un jour de début de l'accès valide"
    },
    "descriptions" : {
      "buyNowDescription" : "Ce cours est Public lors de l'achat",
      "timeUnlockDescription" : "Membres",
      "levelUnlockDescription" : "Les membres uniquement à un certain Plat pourront déconnecter",
      "allMembersDescription" : "Tous les membres ont accès à ce cours",
      "privateChannelDescription" : "Membres d'un canal privé",
      "privateDescription" : "Accès accordé uniquement par l'administrateur"
    },
    "helperText" : {
      "levelBased" : "En fonction du niveau",
      "timeLimited" : "Limite de l'heure",
      "privateBased" : "Privé",
      "free" : "Gratuit",
      "levelAvailableAt" : "disponible à Plat{value}",
      "timeLimitedAfterJoining" : "Envoyez {value} Public au {day}",
      "day" : "Jour",
      "days" : "jours",
      "purchaseToUnlockAccess" : "Acheter ce cours pour déconnecter l'accès",
      "privateCourse" : "Cours privé – Accès accordé uniquement par l'administrateur",
      "locked" : "Ce cours est verrouillé",
      "unlockAtLevel" : "Ce cours se déconnectera à {level}",
      "unlockAfterDays" : "Ce cours se déconnectera après {days} {dayText}",
      "privateChannelBased" : "Base de canaux Privé",
      "externalAccess" : "Autre groupe/offre"
    },
    "manageAccess" : {
      "manageCourses" : "Gérez les cours",
      "revokeCourseAccess" : "Gérer les cours",
      "grantCoursesAccess" : "Accorder l'accès aux cours",
      "removeAccess" : "Supprimer l'accès",
      "grantAccess" : "Accorder l'accès",
      "grant" : "Accorder",
      "clear" : "Effacer",
      "selectAll" : "Sélectionner tout",
      "revokeAccessConfirmTitle" : "Retirer l'accès au cours ?",
      "revokeAccessConfirmMessage" : "Voulez-vous vraiment supprimer l'accès à « {courseName} » pour {userName}?",
      "externalAccessTooltip" : "Suppression impossible : l'utilisateur a accès à partir d'un autre groupe ou d'une autre offre",
      "cannotRevokeAutoAccess" : "Suppression impossible : accès accordé automatiquement selon les paramètres du cours (payant, niveau, heure, ou gratuit)",
      "searchPlaceholder" : "Recherchez des cours",
      "noCoursesFound" : "Aucun cours trouvé",
      "noCoursesSelected" : "Aucun cours n'a été sélectionné pour le moment.",
      "noCoursesAvailable" : "Aucun cours disponible à accorder",
      "noSearchResults" : "Aucun résultat de recherche",
      "failedToLoadCourses" : "Impossible de charger les cours",
      "accessRevoked" : "L'accès au cours a bien été supprimé.",
      "failedToRevokeAccess" : "Échec de la suppression de l'accès au cours",
      "accessGranted" : "L'accès au cours a été accordé avec succès",
      "multipleAccessGranted" : "{count} cours ont bien été accordés.",
      "failedToGrantAccess" : "Échec de l'octroi de l'accès au cours"
    },
    "ariaLabels" : {
      "courseCard" : "Fiche de cours",
      "courseCardActions" : "Actions sur la carte de cours",
      "editCourse" : "Modifier le cours",
      "deleteCourse" : "Supprimer le cours",
      "moveCard" : "Déplacer la carte",
      "copyLink" : "Copier le lien",
      "cardImage" : "Image de la carte de cours"
    }
  },
  "about" : {
    "notifications" : {
      "errorUploadingFile" : "Erreur lors du téléchargement du fichier"
    },
    "uploadLinkVideo" : "Téléverser/Lier une Vidéo",
    "removeMedia" : "Supprimer {fileName} média"
  },
  "leaderboard" : {
    "level" : "Niveau",
    "lastUpdated" : "Dernière mise à jour",
    "members" : "Membres",
    "percentOfMembers" : "{percentage} % des membres",
    "rewards" : "Récompenses",
    "allTime" : "Tout le temps",
    "pointsToLevelUp" : "Points pour monter de niveau",
    "points" : "Points",
    "leaderboard7d" : "Classement (7 jours)",
    "leaderboard30d" : "Leaderboard (30 jours)",
    "leaderboardAlltime" : "Leaderboard (Tout le temps)",
    "yourRank" : "Votre rang",
    "noActivityToShow" : "Aucune activité à afficher",
    "rewardsWillBeDisplayedHere" : "Les récompenses seront affichées ici",
    "seeAllLeaderboards" : "Voir tous les classements",
    "addRewards" : "Ajouter des récompenses",
    "howPointsWork" : "Vous gagnez des Points quand d'autres Membres aiment vos publications ou votre rétroaction. 1 j'aime = 1 point. Cela encourage les Utilisateurs à Générer du contenu de qualité et à interagir avec les autres Membres de leur communauté.",
    "levels" : "Niveaux",
    "levelsDescription" : "Au fur et à mesure que vous gagnez des Points, vous montez de niveau. Votre niveau est affiché en bas à droite de votre avatar. Le nombre de points requis pour passer au niveau suivant est montré via la barre de progression sur la page du classement.",
    "pointsAndLevels" : "Points et coupons"
  },
  "events" : {
    "createEvent" : "Créer un événement",
    "dragAndDrop" : "Faites glisser et déposer un fichier SVG, PNG ou JPG (Max 800 x 400 px)",
    "editEvent" : "Modifier l'événement",
    "addEvent" : "Ajouter un événement",
    "paymentDetails" : "Détails du paiement",
    "event" : "Événement",
    "goBack" : "Retour",
    "cancelEdit" : "Annuler l’édition",
    "cancelEvent" : "Annuler l'événement",
    "next" : "Suivant",
    "saveEvent" : "Sauvegarder l'événement",
    "editRecurringEvent" : "Modifier l'événement récurrent",
    "thisEvent" : "Cet événement",
    "thisAndFollowingEvents" : "Cet événement et les suivants",
    "ok" : "OK",
    "deleteRecurringEvent" : "Supprimer l’événement récurrent",
    "allEvents" : "Tous les événements",
    "adminsFreeForPaidEvents" : " * Les administrateurs peuvent S'inscrire pour des événements payants pour des gratuits",
    "deleteEvent" : "Supprimer l’événement",
    "onceEventDeleted" : "Une fois l'événement supprimé, il ne s'affichera pas dans votre calendrier.",
    "toRegister" : "pour s'inscrire",
    "calendar" : "Calendrier",
    "addToCalendar" : "Ajouter au calendrier",
    "declineRegistration" : "Refuser",
    "paymentFailedMessage" : "Votre paiement a échoué en raison de circonstances imprévues! Veuillez réessayer plus tard",
    "upcoming" : "À venir",
    "noMoreEvents" : "Il n'y a plus d'occurrences à montrer",
    "joinGroupToRegister" : "Vous devez faire partie de cette Collection pour vous inscrire à cet Événement",
    "past" : "Passé",
    "youHaveRegisteredForOneEvent" : "Vous vous êtes inscrit à 1 événement. Nous vous enverrons un rappel un jour avant chaque événement.",
    "upcomingEvents" : "Événements à venir",
    "noUpcomingEvents" : "Aucun événement à venir",
    "pastEvents" : "Événements passés",
    "noPastEvents" : "Pas d'événements passés",
    "noMatchingEventFound" : "Aucun événement correspondant n'a été trouvé",
    "recordings" : "Enregistrements",
    "week" : "Semaine",
    "month" : "Mois",
    "today" : "Aujourd'hui",
    "registrationConfirmed" : "Confirmation d'inscription pour {event}.",
    "eventDeletedOrRestricted" : "L'événement a été supprimé ou restreint",
    "eventDeleted" : "L’événement a été supprimé",
    "eventRestricted" : "Vous n'avez pas accès à cet événement",
    "validations" : {
      "titleValidation" : "Une légende est requise",
      "colorValidation" : "La couleur est obligatoire",
      "startTimeValidation" : "L'heure de début est obligatoire",
      "endTimeValidation" : "L'heure de fin est obligatoire",
      "endTimeAfterStartTime" : "L'heure de fin doit être postérieure à l'heure de début!",
      "startTimeMustBeInFuture" : "L'heure de début doit être dans le futur",
      "locationValidation" : "L'emplacement est requis",
      "locationValidationMobile" : "L'emplacement est req",
      "locationUrlValidation" : "Une URL d'emplacement valide est nécessaire",
      "descriptionValidation" : "Une description est requise",
      "descriptionValidationMaxLength" : "La description ne doit pas dépasser 300 caractères",
      "recaptchaError" : "La vérification a échoué! Veuillez réessayer",
      "repeatIntervalValidation" : "L'occurrence est requise",
      "repeatIntervalValidator" : "L’intervalle de répétition doit être un jour, une semaine, un mois ou une année.",
      "repeatIntervalRequired" : "L'intervalle de répétition est obligatoire.",
      "repeatOccurrenceValidator" : "La fréquence de répétition doit être supérieure à 0.",
      "repeatOccurrenceRequired" : "La fréquence de répétition est obligatoire.",
      "invalidDateFormat" : "Format de date non valide",
      "endDateMustBeAfterStartDate" : "La Date de fin doit être après la Date de début de l'événement",
      "recurringEndDateValidation" : "La Date de fin récurrente est obligatoire",
      "repeatsOnValidation" : "Veuillez sélectionner au moins un jour",
      "invalidDaySelection" : "Sélection de jour non valide",
      "endOptionRequired" : "L'option de fin est obligatoire",
      "levelValidation" : "Veuillez sélectionner un niveau",
      "courseValidation" : "Veuillez sélectionner un cours",
      "channelValidation" : "Veuillez sélectionner une chaîne",
      "eventPriceValidation" : "Le prix est obligatoire et doit être supérieur à {min}"
    },
    "placeholders" : {
      "selectStartTime" : "Sélectionner l'heure de début",
      "selectEndTime" : "Sélectionnez l’heure de fin",
      "selectLocation" : "Sélectionner l'emplacement",
      "locationUrl" : "Lien/Adresse",
      "description" : "Description",
      "selectRecurringEndDate" : "Sélectionnez Date de fin récurrente",
      "selectDate" : "Sélectionner la date",
      "event" : "Événement",
      "selectColor" : "Sélectionnez une couleur",
      "selectAttendees" : "Sélectionner les participants",
      "selectPrivateChannel" : "Sélectionnez le canal privé",
      "selectCourse" : "Sélectionner un cours",
      "selectLevels" : "Sélectionner les Couches",
      "selectCalendar" : "Sélectionne le calendrier"
    },
    "labels" : {
      "startTime" : "Heure de début",
      "endTime" : "Heure de fin",
      "others" : "Autres",
      "oneTimePriceForEventRegistration" : "prix unique pour l'inscription à l'événement.",
      "totalAmount" : "Montant total",
      "cardAuthorizationText" : "En fournissant les détails de votre carte, vous autorisez {locationName} à débiter votre carte pour des paiements futurs conformément à leurs conditions.",
      "secureAndSafePayments" : "Paiements 100 % sécurisés et sûrs",
      "day" : "Jour",
      "week" : "Semaine",
      "month" : "Mois",
      "year" : "Année",
      "recurringEvent" : "L'événement sera-t-il un événement récurrent?",
      "repeatsEvery" : "Répéter tout",
      "repeatsOn" : "Répète le",
      "end" : "Fin",
      "ends" : "Fin",
      "neverEnds" : "Ne finit jamais",
      "orange" : "Orange",
      "red" : "Rouge",
      "blue" : "Bleu",
      "green" : "Vert",
      "violet" : "Violet",
      "purple" : "Pourpre",
      "yellow" : "Jaune",
      "title" : "Titre",
      "color" : "Couleur",
      "allMembers" : "Tous les membres",
      "membersAtALevel" : "Membres au niveau Plat",
      "membersOfACourse" : "Membres d'un cours",
      "membersOfAPrivateChannel" : "Membres d'une chaîne privée",
      "whoCanAttendTheEvent" : "Qui peut participer à l'événement?",
      "channel" : "Canal",
      "course" : "Cours",
      "level" : "Niveau",
      "remindAttendeesByEmail" : "Rappeler aux participants via Courriel 1 Jour Avant",
      "hideLocationFromNonAttendees" : "Cacher l’emplacement aux non-participants.",
      "addChargesToTheEvent" : "Ajouter une facture à l'événement",
      "noPaymentRequired" : "Aucun paiement obligatoire",
      "location" : "Emplacement",
      "link" : "Lien",
      "description" : "Description",
      "timezone" : "Fuseau horaire",
      "eventType" : "Type d’événement",
      "eventTypeChangeWarning" : "Des prix dynamiques pour le Type d'événement s'appliqueront à toutes les occurrences in la ligne.",
      "never" : "Jamais",
      "on" : "Allumé",
      "after" : "Après",
      "occurrences" : "occurrences",
      "selectEventEnd" : "OK",
      "turnOnTestPayments" : "Paiements d'essais au moyen d'une carte d'essai",
      "pay" : "Rémunérer",
      "hideAttendees" : "Cacher les participants de groupe",
      "guests" : "ID {count} l'invité",
      "guestList" : "Liste des Invité",
      "noAttendees" : "Aucun participant pour le moment",
      "viewAttendees" : "Voir les participants",
      "exportAttendees" : "Exporter les participants"
    },
    "notifications" : {
      "eventCreated" : "Présentez des événements avec succès!",
      "pickImageFailed" : "Échec de la sélection de l'image",
      "pickImageFailedContent" : "Une erreur s'est produite lors de la sélection de l'image.",
      "eventUpdated" : "Mise à jour avec succès!",
      "eventCreationFailed" : "La création Événement a échoué!",
      "eventUpdateFailed" : "Mise à jour de Événement",
      "EVENT_CREATE_INVALID_TIME_RANGE" : "L'heure de début doit être antérieure à l'heure de fin.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED" : "L'heure de début doit être dans le futur.",
      "EVENT_CREATE_DURATION_EXCEEDED" : "La durée de l’événement dépasse la limite maximale autorisée.",
      "EVENT_CREATE_FAILED" : "Impossible de créer un événement. Veuillez réessayer.",
      "EVENT_UPDATE_NOT_FOUND" : "Impossible de mettre à jour l'événement car il n'a pas été trouvé.",
      "EVENT_UPDATE_UNAUTHORIZED" : "Vous n'avez pas l'autorisation de mettre à jour cet événement.",
      "EVENT_UPDATE_INVALID_OPERATION" : "Cette action de mise à jour d'événement n'est pas autorisée.",
      "eventDeleted" : "Événement supprimé avec succès!",
      "eventDeletionFailed" : "La suppression de l'événement a échoué!",
      "paymentFailed" : "Le paiement a échoué!",
      "registrationSuccessful" : "Inscription réussie!",
      "registrationFailed" : "Inscription échouée!",
      "addToCalendarFailed" : "Impossible d'inclure l'événement au calendrier!",
      "locationDetailsCopied" : "Détails de l'emplacement copiés dans le presse-papiers!",
      "registrationDeclined" : "Inscription refusée avec succès!",
      "registrationDeclinedFailed" : "Le rejet des inscriptions a échoué!",
      "fetchAttendeesFailed" : "Échec de charger les participants",
      "emailCopied" : "Copier le courriel dans le presse-papiers",
      "exportAttendeesFailed" : "Échec à exporter les participants"
    },
    "selectCalendar" : "Sélectionnez un calendrier",
    "eventImage" : "Image d'événement",
    "errorLoadingEvent" : "Erreur lors du chargement de l'événement"
  },
  "login" : {
    "invite" : "vous a invité à rejoindre"
  },
  "contentReports" : {
    "contentDeleted" : "Le contenu a été supprimé !",
    "noActionTaken" : "Aucune action prise concernant le contenu signalé!",
    "reportedContentNotFound" : "Contenu signalé non trouvé, peut-être déjà traité.",
    "reported" : "Rapporté",
    "viewAllReportedContentHere" : "Vous pouvez voir tout le contenu signalé ici",
    "takeActionOnReportedContent" : "Prendre des mesures concernant le contenu signalé",
    "andOthers" : "et {count} autres",
    "reportedThisPost" : "a rapporté ce post",
    "keep" : "GARDER",
    "remove" : "SUPPRIMER",
    "deleteContent" : "Supprimer le contenu",
    "deleteConfirmation" : "Voulez-vous vraiment supprimer ce contenu ?",
    "noMemberReportedContent" : "Pas de contenu rapporté par les membres",
    "whenMembersReportPostsOrComments" : "Quand les membres signalent des messages ou des commentaires, ils apparaissent ici pour que vous puissiez les examiner. Vous pouvez les garder ou les supprimer, ainsi que suspendre, supprimer ou bloquer les membres qui les ont publiées.",
    "reportedThisComment" : "Vous avez signalé ce commentaire"
  },
  "contentUnavailable" : {
    "thisContentIsntAvailable" : "Ce contenu n’est pas disponible pour le moment",
    "whenThisHappens" : "Lorsque cela arrive, c'est généralement parce que le propriétaire ne l'a partagé qu'avec un petit groupe de personnes ou a changé qui peut le voir ou il a été supprimé"
  },
  "search" : {
    "noResultsFor" : "0 résultats pour « {query} » dans la communauté",
    "noResultsFound" : "Aucun résultat trouvé"
  },
  "noCommunities" : {
    "noCommunitiesFound" : "Aucune communauté trouvée",
    "startCreatingYourOwnCommunities" : "Commencez à créer vos propres communautés et interagissez avec votre public!",
    "noCommunitiesFoundGokollab" : {
      "notJoinedA" : "Non rejoint",
      "communities" : "Communautés",
      "yet" : "Pas encore"
    },
    "noCommunitiesFoundGokollabDescription" : "Découvrez des espaces où les gens partagent des idées, se soutiennent mutuellement et grandissent ensemble."
  },
  "noCourses" : {
    "noCoursesFoundGokollab" : {
      "notEnrolledInA" : "Non inscrit à",
      "course" : "Cours",
      "yet" : "Pas encore"
    },
    "noCoursesFoundGokollabDescription" : "Explorez des cours à fort impact conçus pour vous aider à apprendre, à vous améliorer et à réussir."
  },
  "notFound" : {
    "ohNo" : "oh non...",
    "weHaveHadAnError" : "Nous avons eu une erreur",
    "error404" : "Erreur 404",
    "sorryPleaseCheckBack" : "Désolé... veuillez revenir dans un instant."
  },
  "time" : {
    "justNow" : "Tout maintenant",
    "timeAgo" : "Il y a {value}{unit}",
    "timeAgoFull" : "Il y a  {value} {unit}",
    "units" : {
      "year" : "a",
      "years" : "années",
      "month" : "mois",
      "months" : "mois",
      "week" : "sem",
      "weeks" : "semaines",
      "day" : "j",
      "days" : "jours",
      "hour" : "h",
      "hours" : "heures",
      "minute" : "m",
      "minutes" : "minutes",
      "second" : "s",
      "seconds" : "Secondes",
      "monthly" : "Mensuel",
      "weekly" : "Hebdomadaire",
      "annually" : "Annuel"
    },
    "dayAbbreviations" : {
      "mon" : "Lundi",
      "tue" : "Mardi",
      "wed" : "Mercredi",
      "thu" : "Jeudi",
      "fri" : "Vendredi",
      "sat" : "Samedi",
      "sun" : "Dimanche"
    }
  },
  "emojiPicker" : {
    "notfound" : "Aucun courriel trouvé",
    "recent" : "Fréquence utilisée",
    "smileys" : "SMS",
    "people" : "Personnel et Corps",
    "nature" : "Entreprises et nature",
    "foods" : "Restaurer",
    "activity" : "Activité",
    "places" : "Déplacement et sièges",
    "objects" : "Objets",
    "symbols" : "Symboles",
    "flags" : "Drapeaux",
    "custom" : "Personnalisé"
  },
  "topNavBarHeaderText" : {
    "discussion" : "Clavardage",
    "learning" : "éducation",
    "people" : "Personnel"
  },
  "globalUserProfile" : {
    "ownedBy" : "Appartient à {name}",
    "memberships" : "Abonnements",
    "membershipsInCommon" : "Adhésions ({count} in common)",
    "membersCount" : "{count} membres",
    "contributions" : "{count} contributions à {group}",
    "contributionsFor" : "Contributions pour",
    "justPosts" : "Juste des publications",
    "postAndComments" : "Partager et rétroaction",
    "followSuccess" : "Vous avez commencé à suivre",
    "unfollowSuccess" : "Vous ne suivez plus"
  },
  "profile" : {
    "active" : "Dynamique",
    "ago" : "il y a",
    "bio" : "Biographie"
  },
  "golive" : {
    "golive" : "Passez en direct",
    "liveRoom" : "Salle de diffusion en direct",
    "defaultEventTitle" : "Événement en direct de la communauté",
    "meetingCreationFailed" : "La création de la réunion GoLive a échoué. Veuillez réessayer.",
    "selectVideoSourceToStart" : "Sélectionnez une source vidéo pour démarrer la diffusion en continu",
    "chooseHowToGoLive" : "Choisissez comment vous souhaitez passer en direct",
    "flipCamera" : "Retourner la caméra",
    "participants" : "Membres",
    "chats" : "Clavardages",
    "react" : "React",
    "raise" : "Élever",
    "shareScreen" : "Partager",
    "letsCheckYourCamAndMic" : "Vérifions votre caméra et votre micro",
    "hostedBy" : "Hébergé par",
    "join" : "Rejoindre",
    "needCameraPermission" : "Autorisation de la caméra requise",
    "needMicrophonePermission" : "Autorisation du microphone requise",
    "needSpeakerPermission" : "Autorisation du haut-parleur requise",
    "createLiveVideo" : "Créer une vidéo en direct",
    "host" : "Hôte",
    "chooseWhereToPost" : "Choisissez où publier",
    "whenAreYouGoingLive" : "Quand allez-vous passer en direct?",
    "postingIn" : "publication dans",
    "live" : "Live (en direct)",
    "postDetails" : "Détails de la publication",
    "streamingSoftware" : "Logiciels de diffusion en continu",
    "streamingSoftwareDescription" : "Vous pouvez utiliser un logiciel de diffusion en continu tel que Zoom, OBS ou StreamYard pour diffuser directement. Il suffit de copier l'URL et la clé de diffusion fournies dans les paramètres de votre logiciel de diffusion. Une fois la configuration terminée, lancez votre diffusion dans le logiciel et celle-ci sera automatiquement diffusée en direct sur la plateforme que vous avez sélectionnée.",
    "streamKey" : "Clé de diffusion",
    "streamKeyDescription" : "Cela peut être réutilisé à chaque fois que vous passez en direct. Vous ne pouvez diffuser qu'une seule vidéo en direct à la fois avec votre clé de flux persistant.",
    "serverUrl" : "URL du serveur",
    "serverUrlDescription" : "Cela peut être appelé « URL » ou « Adresse » dans votre logiciel de diffusion en continu.",
    "selectVideoSource" : "Sélectionnez la source vidéo",
    "copyPasteStreamKey" : "Copiez et collez la clé de diffusion dans votre logiciel de diffusion.",
    "copyPasteServerUrl" : "Copiez et collez l'URL du serveur dans votre logiciel de diffusion.",
    "addPostDetails" : "Ajoutez les détails de la publication",
    "enterTitle" : "Entrez le titre",
    "notifyMembers" : "Informez les membres que vous allez passer en direct (envoi uniquement de notifications dans l'application et de notifications push)",
    "notifyMembersMobile" : "Informez les membres que vous allez passer en direct",
    "meetingRoom" : "Salle de réunion",
    "meetingRoomDescription" : "Utilisez la fonctionnalité Salles de réunion pour organiser des sessions en direct où tous les participants peuvent activer leur webcam, réactiver le son et interagir en temps réel. Cela crée une expérience de salle virtuelle similaire à Zoom ou Google Meet, permettant à tout le monde de se voir et de se parler face à face.",
    "cameraControls" : "Contrôles de la caméra",
    "cameraControlsTooltip" : "Configurez les paramètres de votre caméra et de votre audio avant de passer en direct. Assurez-vous que votre caméra et votre microphone sont correctement connectés et disposent des autorisations nécessaires.",
    "selectMediaSource" : "Sélectionnez une source média",
    "startScreenShare" : "Démarrez le partage d’écran",
    "stopScreenShare" : "Arrêtez le partage d’écran",
    "wasLive" : "était en direct",
    "isLive" : "est en direct",
    "goingLive" : "va être diffusé en direct",
    "tapToAddDescription" : "Appuyez pour ajouter une description...",
    "selectChannel" : "Sélectionnez le canal",
    "saveAsPost" : "Gardez la diffusion en direct comme publication",
    "selectVideoSourceTooltip" : "Vous pouvez choisir entre un logiciel de diffusion en continu ou une webcam lorsque vous passez en direct :\n\n1. Logiciels de diffusion en continu\n   • Nous vous fournirons une clé de diffusion et une URL de diffusion.\n   • Vous devez les configurer dans Zoom, OBS ou tout logiciel tiers qui supporte la diffusion en direct.\n\n2. Webcam\n • Diffusez en direct via votre caméra et votre microphone.\n   • Les membres peuvent voir la diffusion en direct et interagir via le clavardage en direct.\n   • En tant qu'hôte, vous pouvez contrôler et révoquer l'accès à la caméra ou au microphone à tout moment.",
    "pleaseSelectCameraMicrophoneSpeaker" : "Veuillez sélectionner la caméra, le microphone et le haut-parleur",
    "pleaseStartStreamBeforeGoingLive" : "Veuillez lancer la diffusion avant de passer en direct",
    "watching" : "Regarder",
    "processingRecording" : "Traitement de l’enregistrement",
    "recordingFailed" : "Enregistrement non disponible",
    "recordingFailedDescription" : "Nous avons rencontré un problème lors du traitement de cette session en direct et l'enregistrement n'a pas pu être sauvegardé",
    "streamEndedRecordingWillBeAvailableSoon" : "Diffusion terminée. L'enregistrement est en cours de traitement et sera disponible sous peu.",
    "joinStream" : "Rejoindre la diffusion",
    "recordingInProgress" : "Enregistrement en cours",
    "recordingNotAvailable" : "Échec de l'enregistrement",
    "leaveSession" : "Quitter la session",
    "endSession" : "Fin de session",
    "rec" : "REC",
    "selectCamera" : "Sélectionnez la caméra",
    "noCamerasFound" : "Aucune caméra n'a été trouvée",
    "cameraPermissionNeeded" : "Autorisation d'accès à la caméra requise",
    "leave" : "Quitter",
    "chooseMicCam" : "Choisissez Micro/Caméra",
    "selectMicrophone" : "Sélectionner le microphone",
    "selectSpeaker" : "Sélectionnez un haut-parleur",
    "noMicrophonesFound" : "Aucun microphone n'a été trouvé",
    "noSpeakersFound" : "Aucun haut-parleur trouvé",
    "microphonePermissionNeeded" : "Autorisation d'accès au microphone requise",
    "speakerPermissionNeeded" : "Autorisation du haut-parleur requise",
    "noParticipantOpenCamOrMic" : "Cette réunion n'a pas été enregistrée, car aucun participant n'a activé son micro ou sa caméra. Les enregistrements ne sont créés que lorsqu'au moins un participant interagit."
  }
}
